{
  "en-US": {
    "24,000 coins · 10 turns": "24,000 coins · 10 turns",
    "3D city unavailable. Your buildings and scores are shown below.": "3D city unavailable. Your buildings and scores are shown below.",
    "A city worth building.": "A city worth building.",
    "A friendly race to the skyline.": "A friendly race to the skyline.",
    "A request identifier is required.": "A request identifier is required.",
    "ADMIN ACCESS": "ADMIN ACCESS",
    "AI PLAYER": "AI PLAYER",
    "AI competitor": "AI competitor",
    "Adding…": "Adding…",
    "Admin · Free": "Admin · Free",
    "All three opponents finished round {round}.": "All three opponents finished round {round}.",
    "An AI player, powered by Experts Alive. Conversations cannot spend coins or change the result.": "An AI player, powered by Experts Alive. Conversations cannot spend coins or change the result.",
    "Ask": "Ask",
    "Ask about their strategy": "Ask about their strategy",
    "Ask your competitor": "Ask your competitor",
    "Available for the random draw": "Available for the random draw",
    "Balanced builder": "Balanced builder",
    "Broadway House": "Broadway House",
    "Brooklyn Crossing": "Brooklyn Crossing",
    "Build": "Build",
    "Build & finish turn": "Build & finish turn",
    "Build and finish challenge turn": "Build and finish challenge turn",
    "Build once or save": "Build once or save",
    "Buy more rolls": "Buy more rolls",
    "CHALLENGE CITY · NEW YORK": "CHALLENGE CITY · NEW YORK",
    "CONNECTING": "CONNECTING",
    "Central Gardens": "Central Gardens",
    "Challenge complete": "Challenge complete",
    "Challenge controls": "Challenge controls",
    "Challenge standings": "Challenge standings",
    "Challenge · Round {v0} of 10": "Challenge · Round {v0} of 10",
    "Challenge · {round} of 10 rounds complete": "Challenge · {round} of 10 rounds complete",
    "Choose any roll package. No charge will be made.": "Choose any roll package. No charge will be made.",
    "Choose challenge landmark": "Choose challenge landmark",
    "Choose one of the five landmarks.": "Choose one of the five landmarks.",
    "Choose one of the thirteen supported languages.": "Choose one of the thirteen supported languages.",
    "Choose your landmark · one upgrade earns one point": "Choose your landmark · one upgrade earns one point",
    "Close ×": "Close ×",
    "Collect result": "Collect result",
    "Collect saves this result in your challenge record. No coins or paid rewards are awarded.": "Collect saves this result in your challenge record. No coins or paid rewards are awarded.",
    "Complete": "Complete",
    "Connect online to talk with your competitor.": "Connect online to talk with your competitor.",
    "Connect to Lucky Estates online to save and play a challenge.": "Connect to Lucky Estates online to save and play a challenge.",
    "DISCONNECTED": "DISCONNECTED",
    "Discuss the match, compare strategies, or ask about this city.": "Discuss the match, compare strategies, or ask about this city.",
    "ERROR": "ERROR",
    "Entire city": "Entire city",
    "Everyone starts on the same block.": "Everyone starts on the same block.",
    "FINAL STANDINGS": "FINAL STANDINGS",
    "Finish your current challenge first.": "Finish your current challenge first.",
    "First place: {names}. You earned {points} points.": "First place: {names}. You earned {points} points.",
    "Game restarted. Everyone keeps {count} remaining challenge turns; no rolls were added.": "Game restarted. Everyone keeps {count} remaining challenge turns; no rolls were added.",
    "Game restarted. Your remaining rolls were preserved.": "Game restarted. Your remaining rolls were preserved.",
    "Harbor Beacon": "Harbor Beacon",
    "IDLE": "IDLE",
    "Keep playing": "Keep playing",
    "LISTENING": "LISTENING",
    "Latest moves": "Latest moves",
    "Level {level} / 3": "Level {level} / 3",
    "Listening — ask your question.": "Listening — ask your question.",
    "Loading challenge…": "Loading challenge…",
    "Loading…": "Loading…",
    "Meet your competitors": "Meet your competitors",
    "Next goal · Start a city challenge": "Next goal · Start a city challenge",
    "No new rolls are added. Your language, avatar, audio preferences, and previously collected gifts are kept.": "No new rolls are added. Your language, avatar, audio preferences, and previously collected gifts are kept.",
    "No purchases needed": "No purchases needed",
    "Not enough coins for an upgrade": "Not enough coins for an upgrade",
    "Opponent language: {language}": "Opponent language: {language}",
    "Opponents completed their turns": "Opponents completed their turns",
    "Optional visits and conversations. Your Lucky guide remains available through Explain this.": "Optional visits and conversations. Your Lucky guide remains available through Explain this.",
    "Or Roll to save and continue automatically.": "Or Roll to save and continue automatically.",
    "PLAYERS · CITY CHALLENGE": "PLAYERS · CITY CHALLENGE",
    "Place {place} · {points} points": "Place {place} · {points} points",
    "Play with {language} opponents": "Play with {language} opponents",
    "Players": "Players",
    "Players ↗": "Players ↗",
    "Prefer to keep your coins?": "Prefer to keep your coins?",
    "Quick builder": "Quick builder",
    "READY": "READY",
    "ROUND {round}": "ROUND {round}",
    "Reconnect": "Reconnect",
    "Reload progress": "Reload progress",
    "Restart Game": "Restart Game",
    "Restart Game?": "Restart Game?",
    "Restarting…": "Restarting…",
    "Rivals take their turns": "Rivals take their turns",
    "Roll again · auto-save coins": "Roll again · auto-save coins",
    "Roll before choosing a building or saving.": "Roll before choosing a building or saving.",
    "Roll challenge dice": "Roll challenge dice",
    "Roll for coins": "Roll for coins",
    "Roll here or use the orange Roll button on Play to take your challenge turn.": "Roll here or use the orange Roll button on Play to take your challenge turn.",
    "Roll, then choose Build or Save above the Roll button.": "Roll, then choose Build or Save above the Roll button.",
    "SPEAKING": "SPEAKING",
    "Save coins": "Save coins",
    "Save coins & finish turn →": "Save coins & finish turn →",
    "Save coins and finish challenge turn": "Save coins and finish challenge turn",
    "Save coins for your next upgrade": "Save coins for your next upgrade",
    "Save your regular game successfully before restarting. Reload if another window changed your game.": "Save your regular game successfully before restarting. Reload if another window changed your game.",
    "Saving your coins. Opponents take their turns first…": "Saving your coins. Opponents take their turns first…",
    "Saving your move and updating the challenge…": "Saving your move and updating the challenge…",
    "Saving…": "Saving…",
    "Select a landmark to look closer": "Select a landmark to look closer",
    "Setting up your city…": "Setting up your city…",
    "Skyline Tower": "Skyline Tower",
    "Start 10-turn challenge": "Start 10-turn challenge",
    "Start 10-turn challenge →": "Start 10-turn challenge →",
    "Start another challenge": "Start another challenge",
    "Stop the response and turn on your microphone.": "Stop the response and turn on your microphone.",
    "THE TEN-TURN CITY CHALLENGE": "THE TEN-TURN CITY CHALLENGE",
    "THINKING": "THINKING",
    "Talk with {name}": "Talk with {name}",
    "The challenge could not be loaded. Try again.": "The challenge could not be loaded. Try again.",
    "The conversation was interrupted. Your challenge is saved; reconnect when ready.": "The conversation was interrupted. Your challenge is saved; reconnect when ready.",
    "The restart could not be completed. Close this panel, reload progress, and try again.": "The restart could not be completed. Close this panel, reload progress, and try again.",
    "The results are saved. Equal scores share a place.": "The results are saved. Equal scores share a place.",
    "There is no new result to collect.": "There is no new result to collect.",
    "This challenge is complete.": "This challenge is complete.",
    "This challenge is no longer current.": "This challenge is no longer current.",
    "This challenge keeps its {language} opponents and progress. Your next challenge or an explicit Restart Game will use {next}.": "This challenge keeps its {language} opponents and progress. Your next challenge or an explicit Restart Game will use {next}.",
    "This landmark is already complete.": "This landmark is already complete.",
    "This resets your regular city and challenge buildings, scores, and coins. Three competitors will be chosen at random again.": "This resets your regular city and challenge buildings, scores, and coins. Three competitors will be chosen at random again.",
    "Three AI city builders. Ten turns. Your next great neighborhood.": "Three AI city builders. Ten turns. Your next great neighborhood.",
    "Three competitors are chosen at random from the six who speak your selected language.": "Three competitors are chosen at random from the six who speak your selected language.",
    "Tower specialist": "Tower specialist",
    "Turn {v0} of 10": "Turn {v0} of 10",
    "Unknown challenge action.": "Unknown challenge action.",
    "Updating your challenge…": "Updating your challenge…",
    "View challenge results": "View challenge results",
    "Visit city": "Visit city",
    "Visiting {v0}": "Visiting {v0}",
    "Wait for the current response, or press Speak to interrupt.": "Wait for the current response, or press Speak to interrupt.",
    "YOU": "YOU",
    "YOUR MOVE": "YOUR MOVE",
    "You": "You",
    "You and three competitors each receive 24,000 challenge coins and ten turns. Roll, then upgrade one landmark or save your coins. Every upgrade earns one point.": "You and three competitors each receive 24,000 challenge coins and ten turns. Roll, then upgrade one landmark or save your coins. Every upgrade earns one point.",
    "You keep your {rolls} regular rolls and {turns} remaining challenge turns.": "You keep your {rolls} regular rolls and {turns} remaining challenge turns.",
    "You need more challenge coins for that upgrade.": "You need more challenge coins for that upgrade.",
    "You rolled {dice} and earned {coins} challenge coins.": "You rolled {dice} and earned {coins} challenge coins.",
    "You rolled {v0}. Choose Build or Save below to finish your turn. All three opponents go next.": "You rolled {v0}. Choose Build or Save below to finish your turn. All three opponents go next.",
    "You saved your coins and continued to the next roll.": "You saved your coins and continued to the next roll.",
    "You saved your coins for a future upgrade.": "You saved your coins for a future upgrade.",
    "You share first place!": "You share first place!",
    "You upgraded {landmark} to level {level}.": "You upgraded {landmark} to level {level}.",
    "Your challenge changed in another window. The latest progress has been loaded.": "Your challenge changed in another window. The latest progress has been loaded.",
    "Your challenge city": "Your challenge city",
    "Your challenge record": "Your challenge record",
    "Your challenge turn": "Your challenge turn",
    "Your city": "Your city",
    "Your opponents take their turns after either choice. Roll again to save automatically, let them play, then take your next roll.": "Your opponents take their turns after either choice. Roll again to save automatically, let them play, then take your next roll.",
    "Your regular city stays separate. Extra rolls from the Shop do not count here. Equal scores share the same place.": "Your regular city stays separate. Extra rolls from the Shop do not count here. Equal scores share the same place.",
    "Your skyline": "Your skyline",
    "Your skyline wins!": "Your skyline wins!",
    "Your turn · rolling the dice…": "Your turn · rolling the dice…",
    "pts": "pts",
    "rolls remaining": "rolls remaining",
    "{coins} challenge coins": "{coins} challenge coins",
    "{coins} challenge coins · Last dice {dice}": "{coins} challenge coins · Last dice {dice}",
    "{coins} coins": "{coins} coins",
    "{count} challenge rounds left": "{count} challenge rounds left",
    "{language} challenge · {round} / 10 rounds complete": "{language} challenge · {round} / 10 rounds complete",
    "{name} rolled {dice}, earned {coins} coins, and saved for a future upgrade.": "{name} rolled {dice}, earned {coins} coins, and saved for a future upgrade.",
    "{name} rolled {dice}, earned {coins} coins, and upgraded {landmark} to level {level}.": "{name} rolled {dice}, earned {coins} coins, and upgraded {landmark} to level {level}.",
    "{points} points": "{points} points",
    "{points} points · {coins} coins": "{points} points · {coins} coins",
    "{rolls} ROLLS REMAINING": "{rolls} ROLLS REMAINING",
    "{rolls} rolls added at no charge.": "{rolls} rolls added at no charge.",
    "{v0} coins · Level {v1} → {v2}": "{v0} coins · Level {v1} → {v2}",
    "{v0} points · {v1} coins": "{v0} points · {v1} coins",
    "{v0} · Level {v1} / 3": "{v0} · Level {v1} / 3",
    "{v0}'s challenge city": "{v0}'s challenge city",
    "{v0}’s skyline": "{v0}’s skyline",
    "← Back to your city": "← Back to your city",
    "◉ Speak": "◉ Speak",
    "◉ Talk": "◉ Talk"
  },
  "zh-CN": {
    "AI PLAYER": "AI 玩家",
    "Build & finish turn": "建造并完成回合",
    "A request identifier is required.": "请求标识符是必需的。",
    "Challenge · {round} of 10 rounds complete": "挑战·10 轮中的 {round} 回合已完成",
    "24,000 coins · 10 turns": "24,000 个硬币·10 个回合",
    "Available for the random draw": "可用于随机抽奖",
    "All three opponents finished round {round}.": "所有三个对手都结束了第 {round} 轮。",
    "Buy more rolls": "多买一卷",
    "Balanced builder": "平衡生成器",
    "CHALLENGE CITY · NEW YORK": "挑战之城·纽约",
    "Central Gardens": "中央花园",
    "Challenge standings": "挑战赛积分榜",
    "A friendly race to the skyline.": "一场冲向天际线的友谊赛。",
    "AI competitor": "AI 竞争对手",
    "Brooklyn Crossing": "布鲁克林隧道",
    "A city worth building.": "一座值得建造的城市。",
    "Ask": "问",
    "Build once or save": "生成一次或保存",
    "An AI player, powered by Experts Alive. Conversations cannot spend coins or change the result.": "由 Experts Alive 提供支持的 AI 玩家。对话不能花费金币或改变结果。",
    "Challenge complete": "挑战已完成",
    "Build": "构建",
    "Build and finish challenge turn": "建造并完成挑战回合",
    "Ask your competitor": "询问你的竞争对手",
    "Challenge controls": "挑战控制",
    "3D city unavailable. Your buildings and scores are shown below.": "3D 城市不可用。您的建筑物和分数如下所示。",
    "Broadway House": "百老汇故居",
    "Challenge · Round {v0} of 10": "挑战赛·第 {v0} 轮（共 10 轮）",
    "CONNECTING": "正在连接",
    "Ask about their strategy": "询问他们的策略",
    "Choose challenge landmark": "选择挑战地标",
    "Choose one of the five landmarks.": "从五个地标中选择一个。",
    "Choose one of the thirteen supported languages.": "从十三种支持的语言中选择一种。",
    "Choose your landmark · one upgrade earns one point": "选择您的地标·一次升级可获得一点积分",
    "Close ×": "关闭 ×",
    "Collect result": "收集结果",
    "Collect saves this result in your challenge record. No coins or paid rewards are awarded.": "Collect 会将此结果保存到您的挑战记录中。不授予任何金币或付费奖励。",
    "Complete": "已完成",
    "Connect online to talk with your competitor.": "在线连接与竞争对手交谈。",
    "Connect to Lucky Estates online to save and play a challenge.": "在线连接幸运庄园以保存并玩挑战。",
    "DISCONNECTED": "断开连接",
    "Discuss the match, compare strategies, or ask about this city.": "讨论比赛、比较策略或询问这座城市的情况。",
    "ERROR": "错误",
    "Entire city": "整个城市",
    "Everyone starts on the same block.": "每个人都从同一个街区开始。",
    "FINAL STANDINGS": "最终积分榜",
    "Finish your current challenge first.": "先完成当前的挑战。",
    "First place: {names}. You earned {points} points.": "第一名：{names}.你获得了 {points} 积分。",
    "Game restarted. Everyone keeps {count} remaining challenge turns; no rolls were added.": "游戏重启了。每个人都保留 {count} 剩余的挑战回合；没有添加任何掷骰子。",
    "Game restarted. Your remaining rolls were preserved.": "游戏重启了。你剩下的面包卷都保存完好了。",
    "Harbor Beacon": "海港信标",
    "IDLE": "空闲",
    "Keep playing": "继续玩",
    "LISTENING": "听",
    "Latest moves": "最新动作",
    "Level {level} / 3": "等级 {level}/3",
    "Listening — ask your question.": "倾听 — 问你的问题。",
    "Loading challenge…": "正在加载挑战...",
    "Loading…": "加载中...",
    "Meet your competitors": "认识你的竞争对手",
    "Next goal · Start a city challenge": "下一个目标·开始城市挑战赛",
    "No new rolls are added. Your language, avatar, audio preferences, and previously collected gifts are kept.": "未添加任何新卷子。您的语言、头像、音频偏好和之前收集的礼物会被保留。",
    "No purchases needed": "无需购买",
    "Not enough coins for an upgrade": "硬币不够升级",
    "Opponent language: {language}": "对手语言：{language}",
    "Opponents completed their turns": "对手完成了回合",
    "Optional visits and conversations. Your Lucky guide remains available through Explain this.": "可选访问和对话。你的《幸运指南》仍然可以通过 “解释这个” 获取。",
    "Or Roll to save and continue automatically.": "或者滚动保存并自动继续。",
    "PLAYERS · CITY CHALLENGE": "玩家·城市挑战赛",
    "Place {place} · {points} points": "放置 {place} · {points} 积分",
    "Play with {language} opponents": "和 {language} 对手一起玩",
    "Players": "玩家",
    "Players ↗": "玩家 ↗",
    "Prefer to keep your coins?": "更愿意保留您的硬币？",
    "Quick builder": "快速生成器",
    "READY": "准备好了",
    "ROUND {round}": "回合 {round}",
    "Reconnect": "重新连接",
    "Reload progress": "重新加载进度",
    "Restart Game": "重启游戏",
    "Restart Game?": "重启游戏？",
    "Restarting…": "正在重启...",
    "Rivals take their turns": "竞争对手轮流上场",
    "Roll again · auto-save coins": "再掷一次·自动保存硬币",
    "Roll before choosing a building or saving.": "在选择建筑物或储蓄之前先滚动。",
    "Roll challenge dice": "掷挑战骰子",
    "Roll for coins": "掷骰子换硬币",
    "Roll here or use the orange Roll button on Play to take your challenge turn.": "在此处滚动，或使用 Play 中的橙色 Roll 按钮进行挑战回合。",
    "Roll, then choose Build or Save above the Roll button.": "滚动，然后选择 “滚动” 按钮上方的 “构建” 或 “保存”。",
    "SPEAKING": "说话",
    "Save coins": "保存硬币",
    "Save coins & finish turn →": "保存硬币并完成回合 →",
    "Save coins and finish challenge turn": "保存金币并完成挑战回合",
    "Save coins for your next upgrade": "为下次升级储存金币",
    "Save your regular game successfully before restarting. Reload if another window changed your game.": "在重启之前成功保存您的常规游戏。如果另一个窗口改变了你的游戏规则，请重新加载。",
    "Saving your coins. Opponents take their turns first…": "保存您的硬币。对手先轮到对手...",
    "Saving your move and updating the challenge…": "保存你的动作并更新挑战...",
    "Saving…": "正在保存...",
    "Select a landmark to look closer": "选择地标仔细观察",
    "Setting up your city…": "设置你的城市...",
    "Skyline Tower": "天际线塔",
    "Start 10-turn challenge": "开始 10 回合挑战",
    "Start 10-turn challenge →": "开始 10 回合挑战 →",
    "Start another challenge": "开始另一个挑战",
    "Stop the response and turn on your microphone.": "停止响应并打开麦克风。",
    "THE TEN-TURN CITY CHALLENGE": "十回合城市挑战赛",
    "THINKING": "思考",
    "Talk with {name}": "与 {name} 交谈",
    "The challenge could not be loaded. Try again.": "无法加载挑战。再试一次。",
    "The conversation was interrupted. Your challenge is saved; reconnect when ready.": "谈话被打断了。您的挑战已保存；准备就绪后重新连接。",
    "The restart could not be completed. Close this panel, reload progress, and try again.": "无法完成重启。关闭此面板，重新加载进度，然后重试。",
    "The results are saved. Equal scores share a place.": "结果已保存。分数相等。",
    "There is no new result to collect.": "没有新的结果可以收集。",
    "This challenge is complete.": "此挑战已完成。",
    "This challenge is no longer current.": "这一挑战已不再是当前的挑战。",
    "This challenge keeps its {language} opponents and progress. Your next challenge or an explicit Restart Game will use {next}.": "这个挑战可以让其 {language} 对手保持进步。你的下一个挑战或明确的重启游戏将使用 {next}。",
    "This landmark is already complete.": "这个地标已经完工。",
    "This resets your regular city and challenge buildings, scores, and coins. Three competitors will be chosen at random again.": "这将重置您的常规城市并挑战建筑物、分数和金币。将再次随机选择三名竞争对手。",
    "Three AI city builders. Ten turns. Your next great neighborhood.": "三位人工智能城市建设者。十个回合。你的下一个好邻居。",
    "Three competitors are chosen at random from the six who speak your selected language.": "从六名讲您所选语言的竞争对手中随机选出三名。",
    "Tower specialist": "塔楼专家",
    "Turn {v0} of 10": "第 10 回合 {v0}",
    "Unknown challenge action.": "未知的挑战动作。",
    "Updating your challenge…": "正在更新你的挑战...",
    "View challenge results": "查看挑战赛结果",
    "Visit city": "参观城市",
    "Visiting {v0}": "正在访问 {v0}",
    "Wait for the current response, or press Speak to interrupt.": "等待当前响应，或按 Speak 打断。",
    "YOU": "你",
    "YOUR MOVE": "你的举动",
    "You": "你",
    "You and three competitors each receive 24,000 challenge coins and ten turns. Roll, then upgrade one landmark or save your coins. Every upgrade earns one point.": "你和三名竞争对手各获得24,000个挑战金币和十个回合。掷骰子，然后升级一个地标或保存金币。每次升级都会获得一点积分。",
    "You keep your {rolls} regular rolls and {turns} remaining challenge turns.": "你保留你的 {rolls} 普通掷骰子和剩余的 {turns} 个挑战回合。",
    "You need more challenge coins for that upgrade.": "你需要更多的挑战金币才能升级。",
    "You rolled {dice} and earned {coins} challenge coins.": "你掷了 {dice} 并获得了 {coins} 挑战币。",
    "You rolled {v0}. Choose Build or Save below to finish your turn. All three opponents go next.": "你掷了 {v0}。选择下方的 “构建” 或 “保存” 完成回合。接下来是所有三个对手。",
    "You saved your coins and continued to the next roll.": "您保存了硬币并继续下一轮。",
    "You saved your coins for a future upgrade.": "您保存了硬币以备将来升级。",
    "You share first place!": "你分享第一名！",
    "You upgraded {landmark} to level {level}.": "你将 {landmark} 升级到了 {level} 级。",
    "Your challenge changed in another window. The latest progress has been loaded.": "你的挑战在另一个窗口中发生了变化。最新进度已加载。",
    "Your challenge city": "你的挑战城市",
    "Your challenge record": "你的挑战记录",
    "Your challenge turn": "你的挑战回来了",
    "Your city": "你的城市",
    "Your opponents take their turns after either choice. Roll again to save automatically, let them play, then take your next roll.": "你的对手在任一选择之后轮流出局。再次滚动即可自动保存，让他们开始游戏，然后进行下一轮游戏。",
    "Your regular city stays separate. Extra rolls from the Shop do not count here. Equal scores share the same place.": "您的常规城市是分开的。从商店购买的额外卷子不计算在内。分数相等。",
    "Your skyline": "你的天际线",
    "Your skyline wins!": "你的天际线获胜！",
    "Your turn · rolling the dice…": "轮到你了·掷骰子...",
    "pts": "pts",
    "rolls remaining": "剩余掷骰次数",
    "{coins} challenge coins": "{coins} 挑战币",
    "{coins} challenge coins · Last dice {dice}": "{coins} 挑战币·最后一个骰子 {dice}",
    "{coins} coins": "{coins} 硬币",
    "{count} challenge rounds left": "{count} 挑战回合还剩下",
    "{language} challenge · {round} / 10 rounds complete": "{language} 挑战·{round}/10 轮已完成",
    "{name} rolled {dice}, earned {coins} coins, and saved for a future upgrade.": "{name} 掷出 {dice}，获得了 {coins} 个硬币，并存了钱以备将来升级。",
    "{name} rolled {dice}, earned {coins} coins, and upgraded {landmark} to level {level}.": "{name} 掷出 {dice}，获得了 {coins} 金币，并将 {landmark} 升级到了 {level} 级。",
    "{points} points": "{points} 积分",
    "{points} points · {coins} coins": "{points} 积分·{coins} 硬币",
    "{rolls} ROLLS REMAINING": "剩余 {rolls} 次掷骰机会",
    "{v0} coins · Level {v1} → {v2}": "{v0} 硬币·等级 {v1} → {v2}",
    "{v0} points · {v1} coins": "{v0} 积分·{v1} 硬币",
    "{v0} · Level {v1} / 3": "{v0} · 等级 {v1}/3",
    "{v0}'s challenge city": "{v0} 的挑战之城",
    "{v0}’s skyline": "{v0} 的天际线",
    "← Back to your city": "← 回到你的城市",
    "◉ Speak": "◉ 说话",
    "◉ Talk": "◉ 谈话",
    "Choose any roll package. No charge will be made.": "选择任何卷装包装。不收取任何费用。",
    "Adding…": "正在添加...",
    "{rolls} rolls added at no charge.": "{rolls} 卷是免费添加的。",
    "Admin · Free": "管理员·免费",
    "ADMIN ACCESS": "管理员访问权限",
    "{rolls} ROLLS": "{rolls} 次掷骰机会"
  },
  "fr-FR": {
    "24,000 coins · 10 turns": "24 000 pièces · 10 tours",
    "3D city unavailable. Your buildings and scores are shown below.": "Ville 3D non disponible. Vos bâtiments et vos scores sont indiqués ci-dessous.",
    "A city worth building.": "Une ville qui vaut la peine d'être construite.",
    "A friendly race to the skyline.": "Une course amicale vers la ligne d'horizon.",
    "A request identifier is required.": "Un identifiant de demande est requis.",
    "AI PLAYER": "JOUEUR AI",
    "AI competitor": "Compétiteur d'IA",
    "Admin · Free": "Admin · Gratuit",
    "All three opponents finished round {round}.": "Les trois adversaires ont terminé le round {round}.",
    "An AI player, powered by Experts Alive. Conversations cannot spend coins or change the result.": "Un joueur IA, propulsé par Experts Alive. Les conversations ne peuvent pas dépenser de pièces ni modifier le résultat.",
    "Ask": "Demandez",
    "Ask about their strategy": "Renseignez-vous sur leur stratégie",
    "Ask your competitor": "Demandez à votre concurrent",
    "Available for the random draw": "Disponible pour le tirage au sort",
    "Balanced builder": "Constructeur équilibré",
    "Broadway House": "Maison Broadway",
    "Brooklyn Crossing": "Passage de Brooklyn",
    "Build": "Construisez",
    "Build & finish turn": "Construisez et terminez le tour",
    "Build and finish challenge turn": "Construisez et terminez le tour de défi",
    "Build once or save": "Créez une fois ou sauvegardez",
    "Buy more rolls": "Achetez plus de rouleaux",
    "CHALLENGE CITY · NEW YORK": "CHALLENGE CITY · NEW YORK",
    "CONNECTING": "SE CONNECTANT",
    "Central Gardens": "Jardins centraux",
    "Challenge complete": "Défi terminé",
    "Challenge controls": "Contrôles des défis",
    "Challenge standings": "Classement du challenge",
    "Challenge · Round {v0} of 10": "Défi · Tour {v0} de 10",
    "Challenge · {round} of 10 rounds complete": "Défi · {round} sur 10 manches terminées",
    "Adding…": "Ajouter...",
    "Choose challenge landmark": "Choisissez le point de repère du défi",
    "Choose one of the five landmarks.": "Choisissez l'un des cinq points de repère.",
    "Choose one of the thirteen supported languages.": "Choisissez l'une des treize langues prises en charge.",
    "Choose your landmark · one upgrade earns one point": "Choisissez votre point de repère · une amélioration rapporte un point",
    "Close ×": "Fermer ×",
    "Collect result": "Collecter le résultat",
    "Collect saves this result in your challenge record. No coins or paid rewards are awarded.": "Collect enregistre ce résultat dans votre fiche de défi. Aucune pièce ou récompense payante n'est attribuée.",
    "Complete": "Achevée",
    "Connect online to talk with your competitor.": "Connectez-vous en ligne pour discuter avec votre concurrent.",
    "Connect to Lucky Estates online to save and play a challenge.": "Connectez-vous à Lucky Estates en ligne pour économiser et relever un défi.",
    "DISCONNECTED": "DÉCONNECTÉ",
    "Discuss the match, compare strategies, or ask about this city.": "Discutez du match, comparez les stratégies ou posez des questions sur cette ville.",
    "ERROR": "ERREUR",
    "Entire city": "Ville entière",
    "Everyone starts on the same block.": "Tout le monde commence sur le même bloc.",
    "FINAL STANDINGS": "CLASSEMENT FINAL",
    "Finish your current challenge first.": "Terminez d'abord votre défi actuel.",
    "First place: {names}. You earned {points} points.": "Première place : {names}. Vous avez cumulé {points} points.",
    "Game restarted. Everyone keeps {count} remaining challenge turns; no rolls were added.": "Le jeu a redémarré. Tout le monde conserve {count} tours de défi restants ; aucun lancer n'a été ajouté.",
    "Game restarted. Your remaining rolls were preserved.": "Le jeu a redémarré. Vos rouleaux restants ont été conservés.",
    "Harbor Beacon": "Balise portuaire",
    "IDLE": "INACTIF",
    "Keep playing": "Continuez à jouer",
    "LISTENING": "ÉCOUTANT",
    "Latest moves": "Les derniers mouvements",
    "Level {level} / 3": "Niveau {level}/3",
    "Listening — ask your question.": "Écouter : posez votre question.",
    "Loading challenge…": "Défi de chargement...",
    "Loading…": "Chargement en cours...",
    "Meet your competitors": "Rencontrez vos concurrents",
    "Next goal · Start a city challenge": "Prochain objectif · Lancer un défi urbain",
    "No new rolls are added. Your language, avatar, audio preferences, and previously collected gifts are kept.": "Aucun nouveau rouleau n'est ajouté. Votre langue, votre avatar, vos préférences audio et les cadeaux précédemment collectés sont conservés.",
    "No purchases needed": "Aucun achat n'est nécessaire",
    "Not enough coins for an upgrade": "Pas assez de pièces pour une mise à niveau",
    "Opponent language: {language}": "Langue de l'adversaire : {language}",
    "Opponents completed their turns": "Les adversaires ont terminé leur tour",
    "Optional visits and conversations. Your Lucky guide remains available through Explain this.": "Visites et conversations facultatives. Votre guide Lucky reste disponible via Explain this.",
    "Or Roll to save and continue automatically.": "Ou utilisez la fonction Roll pour enregistrer et continuer automatiquement.",
    "PLAYERS · CITY CHALLENGE": "JOUEURS · CITY CHALLENGE",
    "Place {place} · {points} points": "Lieu {place} · {points} points",
    "Play with {language} opponents": "Jouez avec des adversaires {language}",
    "Players": "joueurs",
    "Players ↗": "Joueurs ↗",
    "Prefer to keep your coins?": "Vous préférez conserver vos pièces ?",
    "Quick builder": "Générateur rapide",
    "READY": "PRÊT",
    "ROUND {round}": "RONDE {round}",
    "Reconnect": "Reconnecter",
    "Reload progress": "Progression du rechargement",
    "Restart Game": "Redémarrer le jeu",
    "Restart Game?": "Redémarrer le jeu ?",
    "Restarting…": "Redémarrage...",
    "Rivals take their turns": "Les rivaux jouent à tour de rôle",
    "Roll again · auto-save coins": "Lancer à nouveau · sauvegarde automatique des pièces",
    "Roll before choosing a building or saving.": "Roulez avant de choisir un bâtiment ou d'économiser.",
    "Roll challenge dice": "Lancez les dés du défi",
    "Roll for coins": "Rouleau pour pièces",
    "Roll here or use the orange Roll button on Play to take your challenge turn.": "Lancez ici ou utilisez le bouton orange Lancer sur Play pour relever le défi à votre tour.",
    "Roll, then choose Build or Save above the Roll button.": "Lancer, puis choisissez Créer ou Enregistrer au-dessus du bouton Lancer.",
    "SPEAKING": "PARLANT",
    "Save coins": "Économisez des pièces",
    "Save coins & finish turn →": "Économisez des pièces et terminez le tour →",
    "Save coins and finish challenge turn": "Économisez des pièces et terminez le tour de défi",
    "Save coins for your next upgrade": "Économisez des pièces pour votre prochaine mise à niveau",
    "Save your regular game successfully before restarting. Reload if another window changed your game.": "Sauvegardez votre partie habituelle avec succès avant de la redémarrer. Rechargez si une autre fenêtre a changé votre jeu.",
    "Saving your coins. Opponents take their turns first…": "Économisez vos pièces. Les adversaires jouent d'abord à tour de rôle...",
    "Saving your move and updating the challenge…": "Sauvegarder votre déménagement et mettre à jour le défi...",
    "Saving…": "Économiser...",
    "Select a landmark to look closer": "Sélectionnez un point de repère pour le regarder de plus près",
    "Setting up your city…": "Configuration de votre ville...",
    "Skyline Tower": "Tour Skyline",
    "Start 10-turn challenge": "Commencez un défi en 10 tours",
    "Start 10-turn challenge →": "Commencez le défi en 10 tours →",
    "Start another challenge": "Lancer un autre défi",
    "Stop the response and turn on your microphone.": "Arrêtez la réponse et allumez votre microphone.",
    "THE TEN-TURN CITY CHALLENGE": "LE DÉFI DES VILLES EN DIX TOURS",
    "THINKING": "PENSANT",
    "Talk with {name}": "Discutez avec {name}",
    "The challenge could not be loaded. Try again.": "Le challenge n'a pas pu être chargé. Réessayez.",
    "The conversation was interrupted. Your challenge is saved; reconnect when ready.": "La conversation a été interrompue. Votre défi est enregistré ; reconnectez-vous lorsque vous êtes prêt.",
    "The restart could not be completed. Close this panel, reload progress, and try again.": "Le redémarrage n'a pas pu être terminé. Fermez ce panneau, rechargez la progression et réessayez.",
    "The results are saved. Equal scores share a place.": "Les résultats sont enregistrés. Des scores égaux se partagent une place.",
    "There is no new result to collect.": "Il n'y a aucun nouveau résultat à collecter.",
    "This challenge is complete.": "Ce défi est terminé.",
    "This challenge is no longer current.": "Ce défi n'est plus d'actualité.",
    "This challenge keeps its {language} opponents and progress. Your next challenge or an explicit Restart Game will use {next}.": "Ce challenge permet de conserver ses adversaires {language} et de progresser. Votre prochain défi ou un Restart Game explicite utilisera {next}.",
    "This landmark is already complete.": "Ce monument est déjà terminé.",
    "This resets your regular city and challenge buildings, scores, and coins. Three competitors will be chosen at random again.": "Cela réinitialise votre ville habituelle et défie les bâtiments, les scores et les pièces. Trois concurrents seront à nouveau choisis au hasard.",
    "Three AI city builders. Ten turns. Your next great neighborhood.": "Trois constructeurs de villes basés sur l'IA. Dix tours. Votre prochain quartier génial.",
    "Three competitors are chosen at random from the six who speak your selected language.": "Trois concurrents sont choisis au hasard parmi les six qui parlent la langue que vous avez sélectionnée.",
    "Tower specialist": "Spécialiste des tours",
    "Turn {v0} of 10": "Tour {v0} de 10",
    "Unknown challenge action.": "Action de défi inconnue.",
    "Updating your challenge…": "Mise à jour de votre défi...",
    "View challenge results": "Afficher les résultats du challenge",
    "Visit city": "Visitez la ville",
    "Visiting {v0}": "En visite à {v0}",
    "Wait for the current response, or press Speak to interrupt.": "Attendez la réponse en cours ou appuyez sur Parler pour interrompre.",
    "YOU": "TU",
    "YOUR MOVE": "VOTRE DÉMÉNAGEMENT",
    "You": "Vous",
    "You and three competitors each receive 24,000 challenge coins and ten turns. Roll, then upgrade one landmark or save your coins. Every upgrade earns one point.": "Vous et trois concurrents recevez chacun 24 000 pièces de défi et dix tours. Lancez, puis améliorez un point de repère ou économisez vos pièces. Chaque amélioration rapporte un point.",
    "You keep your {rolls} regular rolls and {turns} remaining challenge turns.": "Vous conservez vos lancers réguliers {rolls} et vos {turns} tours de défi restants.",
    "You need more challenge coins for that upgrade.": "Vous avez besoin de plus de pièces de défi pour cette amélioration.",
    "You rolled {dice} and earned {coins} challenge coins.": "Vous avez obtenu {dice} et gagné {coins} pièces de défi.",
    "You rolled {v0}. Choose Build or Save below to finish your turn. All three opponents go next.": "Tu as obtenu {v0}. Choisissez Construire ou Enregistrer ci-dessous pour terminer votre tour. Les trois adversaires passent ensuite.",
    "You saved your coins and continued to the next roll.": "Vous avez sauvegardé vos pièces et vous êtes passé au lancer suivant.",
    "You saved your coins for a future upgrade.": "Vous avez enregistré vos pièces pour une future mise à niveau.",
    "You share first place!": "Vous partagez la première place !",
    "You upgraded {landmark} to level {level}.": "Vous avez amélioré {landmark} au niveau {level}.",
    "Your challenge changed in another window. The latest progress has been loaded.": "Votre défi a changé dans une autre fenêtre. La dernière progression a été chargée.",
    "Your challenge city": "Votre ville à défis",
    "Your challenge record": "Votre palmarès de défis",
    "Your challenge turn": "À votre tour de défi",
    "Your city": "Votre ville",
    "Your opponents take their turns after either choice. Roll again to save automatically, let them play, then take your next roll.": "Vos adversaires jouent à tour de rôle après l'un ou l'autre choix. Lancez à nouveau pour enregistrer automatiquement, laissez-les jouer, puis passez au lancer suivant.",
    "Your regular city stays separate. Extra rolls from the Shop do not count here. Equal scores share the same place.": "Votre ville habituelle reste séparée. Les rouleaux supplémentaires provenant de la boutique ne sont pas pris en compte ici. Des scores égaux se partagent la même place.",
    "Your skyline": "Votre ligne d'horizon",
    "Your skyline wins!": "Votre ligne d'horizon l'emporte !",
    "Your turn · rolling the dice…": "À ton tour · lancer les dés...",
    "pts": "points",
    "rolls remaining": "lancers restants",
    "{coins} challenge coins": "Pièces de défi {coins}",
    "{coins} challenge coins · Last dice {dice}": "{coins} challenge coins · Derniers dés {dice}",
    "{coins} coins": "Pièces {coins}",
    "{count} challenge rounds left": "Il reste {count} manches de défi",
    "{language} challenge · {round} / 10 rounds complete": "Défi {language} · {round}/10 manches terminées",
    "{name} rolled {dice}, earned {coins} coins, and saved for a future upgrade.": "{name} a obtenu {dice}, gagné {coins} pièces et économisé pour une future mise à niveau.",
    "{name} rolled {dice}, earned {coins} coins, and upgraded {landmark} to level {level}.": "{name} a obtenu {dice}, gagné {coins} pièces et a fait passer {landmark} au niveau {level}.",
    "{points} points": "{points} points",
    "{points} points · {coins} coins": "{points} points · {coins} pièces",
    "{rolls} ROLLS REMAINING": "{rolls} LANCERS RESTANTS",
    "{v0} coins · Level {v1} → {v2}": "{v0} pièces · Niveau {v1} → {v2}",
    "{v0} points · {v1} coins": "{v0} points · {v1} pièces",
    "{v0} · Level {v1} / 3": "{v0} · Niveau {v1}/3",
    "{v0}'s challenge city": "La ville du défi {v0}",
    "{v0}’s skyline": "Horizon de {v0}",
    "← Back to your city": "← Retournez dans votre ville",
    "◉ Speak": "⁃ Parlez",
    "◉ Talk": "⁃ Discuter",
    "ADMIN ACCESS": "ACCÈS ADMINISTRATEUR",
    "Choose any roll package. No charge will be made.": "Choisissez n'importe quel emballage de rouleaux. Aucun frais ne sera facturé.",
    "{rolls} rolls added at no charge.": "Rouleaux {rolls} ajoutés gratuitement.",
    "{rolls} ROLLS": "{rolls} LANCERS"
  },
  "de-DE": {
    "24,000 coins · 10 turns": "24.000 Münzen · 10 Umdrehungen",
    "3D city unavailable. Your buildings and scores are shown below.": "3D-Stadt nicht verfügbar. Ihre Gebäude und Punktzahlen werden unten angezeigt.",
    "A city worth building.": "Eine Stadt, die es wert ist gebaut zu werden.",
    "A friendly race to the skyline.": "Ein freundschaftliches Rennen zur Skyline.",
    "A request identifier is required.": "Eine Anforderungs-ID ist erforderlich.",
    "AI PLAYER": "KI-SPIELER",
    "AI competitor": "KI-Konkurrent",
    "All three opponents finished round {round}.": "Alle drei Gegner beendeten Runde {round}.",
    "An AI player, powered by Experts Alive. Conversations cannot spend coins or change the result.": "Ein KI-Spieler, unterstützt von Experts Alive. Konversationen können keine Münzen ausgeben oder das Ergebnis ändern.",
    "Ask": "Frag",
    "Ask about their strategy": "Fragen Sie nach ihrer Strategie",
    "Ask your competitor": "Fragen Sie Ihren Konkurrenten",
    "Available for the random draw": "Verfügbar für die zufällige Ziehung",
    "Balanced builder": "Ausgewogener Baumeister",
    "Broadway House": "Broadway-Haus",
    "Brooklyn Crossing": "Brooklyn-Kreuzung",
    "Build": "Bauen",
    "Build & finish turn": "Runde bauen und beenden",
    "Build and finish challenge turn": "Baue und beende die Herausforderungsrunde",
    "Build once or save": "Einmal bauen oder speichern",
    "Buy more rolls": "Kaufe mehr Rollen",
    "CHALLENGE CITY · NEW YORK": "HERAUSFORDERUNGSSTADT · NEW YORK",
    "CONNECTING": "VERBINDEND",
    "Central Gardens": "Zentrale Gärten",
    "Challenge complete": "Herausforderung abgeschlossen",
    "Challenge controls": "Steuerung herausfordern",
    "Challenge standings": "Challenge-Tabellen",
    "Challenge · Round {v0} of 10": "Herausforderung · Runde {v0} von 10",
    "Challenge · {round} of 10 rounds complete": "Herausforderung · {round} von 10 Runden abgeschlossen",
    "Choose challenge landmark": "Wähle einen Meilenstein der Herausforderung",
    "Choose one of the five landmarks.": "Wählen Sie eines der fünf Wahrzeichen.",
    "Choose one of the thirteen supported languages.": "Wählen Sie eine der dreizehn unterstützten Sprachen.",
    "Choose your landmark · one upgrade earns one point": "Wähle dein Wahrzeichen · ein Upgrade bringt dir einen Punkt",
    "Close ×": "Schliessen ×",
    "Collect result": "Ergebnis sammeln",
    "Collect saves this result in your challenge record. No coins or paid rewards are awarded.": "Collect speichert dieses Ergebnis in deinem Challenge-Rekord. Es werden keine Münzen oder bezahlten Belohnungen vergeben.",
    "Complete": "Vollständig",
    "Connect online to talk with your competitor.": "Stellen Sie eine Online-Verbindung her, um mit Ihrem Konkurrenten zu sprechen.",
    "Connect to Lucky Estates online to save and play a challenge.": "Verbinde dich online mit Lucky Estates, um zu speichern und eine Herausforderung zu spielen.",
    "DISCONNECTED": "GETRENNT",
    "Discuss the match, compare strategies, or ask about this city.": "Besprechen Sie das Spiel, vergleichen Sie Strategien oder fragen Sie nach dieser Stadt.",
    "ERROR": "FEHLER",
    "Entire city": "Ganze Stadt",
    "Everyone starts on the same block.": "Jeder beginnt im selben Block.",
    "FINAL STANDINGS": "ENDSTAND",
    "Finish your current challenge first.": "Schließe zuerst deine aktuelle Herausforderung ab.",
    "First place: {names}. You earned {points} points.": "Erster Platz: {names}. Du hast {points} Punkte verdient.",
    "Game restarted. Everyone keeps {count} remaining challenge turns; no rolls were added.": "Spiel wurde neu gestartet. Jeder behält {count} in den verbleibenden Herausforderungsrunden; es wurden keine Würfe hinzugefügt.",
    "Game restarted. Your remaining rolls were preserved.": "Spiel wurde neu gestartet. Ihre restlichen Brötchen wurden konserviert.",
    "Harbor Beacon": "Hafensignal",
    "IDLE": "UNTÄTIG",
    "Keep playing": "Spiel weiter",
    "LISTENING": "ZUHÖREND",
    "Latest moves": "Letzte Spielzüge",
    "Level {level} / 3": "Stufe {level}/3",
    "Listening — ask your question.": "Zuhören — stell deine Frage.",
    "Loading challenge…": "Herausforderung wird geladen...",
    "Loading…": "Wird geladen...",
    "Meet your competitors": "Lernen Sie Ihre Konkurrenten kennen",
    "Next goal · Start a city challenge": "Nächstes Ziel · Starte eine Stadtherausforderung",
    "No new rolls are added. Your language, avatar, audio preferences, and previously collected gifts are kept.": "Es werden keine neuen Rollen hinzugefügt. Deine Sprache, dein Avatar, deine Audiopräferenzen und zuvor gesammelte Geschenke werden beibehalten.",
    "No purchases needed": "Keine Einkäufe erforderlich",
    "Not enough coins for an upgrade": "Nicht genug Münzen für ein Upgrade",
    "Opponent language: {language}": "Sprache des Gegners: {language}",
    "Opponents completed their turns": "Die Gegner haben ihre Züge abgeschlossen",
    "Optional visits and conversations. Your Lucky guide remains available through Explain this.": "Optionale Besuche und Gespräche. Ihr Lucky-Guide ist weiterhin über Explain this verfügbar.",
    "Or Roll to save and continue automatically.": "Oder rollen Sie, um zu speichern und automatisch fortzufahren.",
    "PLAYERS · CITY CHALLENGE": "SPIELER · CITY CHALLENGE",
    "Place {place} · {points} points": "Platz {place} · {points} Punkte",
    "Play with {language} opponents": "Spiele mit {language} -Gegnern",
    "Players": "Spieler",
    "Players ↗": "Spieler ↗",
    "Prefer to keep your coins?": "Möchten Sie Ihre Münzen lieber behalten?",
    "Quick builder": "Schneller Builder",
    "READY": "BEREIT",
    "ROUND {round}": "RUNDE {round}",
    "Reconnect": "Erneut verbinden",
    "Reload progress": "Fortschritt neu laden",
    "Restart Game": "Spiel neu starten",
    "Restart Game?": "Spiel neu starten?",
    "Restarting…": "Wird neu gestartet...",
    "Rivals take their turns": "Rivalen sind an der Reihe",
    "Roll again · auto-save coins": "Noch einmal würfeln · Münzen automatisch speichern",
    "Roll before choosing a building or saving.": "Wirf, bevor du ein Gebäude auswählst oder sparst.",
    "Roll challenge dice": "Wirf Herausforderungswürfel",
    "Roll for coins": "Rolle für Münzen",
    "Roll here or use the orange Roll button on Play to take your challenge turn.": "Würfeln Sie hier oder verwenden Sie die orangefarbene Würfeltaste bei Spielen, um an der Reihe zu sein.",
    "Roll, then choose Build or Save above the Roll button.": "Rollen Sie und wählen Sie dann über der Schaltfläche Rollen die Option Erstellen oder Speichern.",
    "SPEAKING": "SPRECHEN",
    "Save coins": "Münzen sparen",
    "Save coins & finish turn →": "Münzen sparen und Runde beenden →",
    "Save coins and finish challenge turn": "Spare Münzen und beende die Herausforderungsrunde",
    "Save coins for your next upgrade": "Spare Münzen für dein nächstes Upgrade",
    "Save your regular game successfully before restarting. Reload if another window changed your game.": "Speichere dein reguläres Spiel erfolgreich, bevor du es neu startest. Lade es erneut, falls ein anderes Fenster dein Spiel verändert hat.",
    "Saving your coins. Opponents take their turns first…": "Speichern Sie Ihre Münzen. Die Gegner sind zuerst an der Reihe...",
    "Saving your move and updating the challenge…": "Speichere deinen Zug und aktualisiere die Herausforderung...",
    "Saving…": "Wird gespeichert...",
    "Select a landmark to look closer": "Wählen Sie eine Sehenswürdigkeit aus, um genauer hinzuschauen",
    "Setting up your city…": "Deine Stadt einrichten...",
    "Skyline Tower": "Skyline-Turm",
    "Start 10-turn challenge": "Starte die 10-Runden-Herausforderung",
    "Start 10-turn challenge →": "Starte die 10-Turn-Herausforderung →",
    "Start another challenge": "Starte eine weitere Herausforderung",
    "Stop the response and turn on your microphone.": "Stoppen Sie die Reaktion und schalten Sie Ihr Mikrofon ein.",
    "THE TEN-TURN CITY CHALLENGE": "DIE ZEHN-TURN-STADTHERAUSFORDERUNG",
    "THINKING": "DENKEN",
    "Talk with {name}": "Sprich mit {name}",
    "The challenge could not be loaded. Try again.": "Die Herausforderung konnte nicht geladen werden. Versuchen Sie es erneut.",
    "The conversation was interrupted. Your challenge is saved; reconnect when ready.": "Das Gespräch wurde unterbrochen. Ihre Herausforderung wurde gespeichert. Stellen Sie die Verbindung wieder her, wenn Sie fertig sind.",
    "The restart could not be completed. Close this panel, reload progress, and try again.": "Der Neustart konnte nicht abgeschlossen werden. Schließen Sie dieses Fenster, laden Sie den Fortschritt neu und versuchen Sie es erneut.",
    "The results are saved. Equal scores share a place.": "Die Ergebnisse werden gespeichert. Gleiche Punktzahlen teilen sich einen Platz.",
    "There is no new result to collect.": "Es gibt kein neues Ergebnis zum Sammeln.",
    "This challenge is complete.": "Diese Herausforderung ist abgeschlossen.",
    "This challenge is no longer current.": "Diese Herausforderung ist nicht mehr aktuell.",
    "This challenge keeps its {language} opponents and progress. Your next challenge or an explicit Restart Game will use {next}.": "Diese Herausforderung hält ihre {language} -Gegner und macht Fortschritte. Bei deiner nächsten Herausforderung oder einem expliziten Neustart des Spiels wird {next} verwendet.",
    "This landmark is already complete.": "Dieses Wahrzeichen ist bereits fertiggestellt.",
    "This resets your regular city and challenge buildings, scores, and coins. Three competitors will be chosen at random again.": "Dadurch wird deine reguläre Stadt zurückgesetzt und Gebäude, Punkte und Münzen herausgefordert. Drei Teilnehmer werden erneut nach dem Zufallsprinzip ausgewählt.",
    "Three AI city builders. Ten turns. Your next great neighborhood.": "Drei KI-Stadtbauer. Zehn Kurven. Deine nächste tolle Nachbarschaft.",
    "Three competitors are chosen at random from the six who speak your selected language.": "Drei Teilnehmer werden nach dem Zufallsprinzip aus den sechs Teilnehmern ausgewählt, die Ihre gewählte Sprache sprechen.",
    "Tower specialist": "Turmspezialist",
    "Turn {v0} of 10": "Runde {v0} von 10",
    "Unknown challenge action.": "Unbekannte Herausforderungsaktion.",
    "Updating your challenge…": "Deine Herausforderung wird aktualisiert...",
    "View challenge results": "Challenge-Ergebnisse anzeigen",
    "Visit city": "Stadt besuchen",
    "Visiting {v0}": "Zu Besuch bei {v0}",
    "Wait for the current response, or press Speak to interrupt.": "Warten Sie auf die aktuelle Antwort oder drücken Sie Speak, um zu unterbrechen.",
    "YOU": "DU",
    "YOUR MOVE": "DEIN ZUG",
    "You": "Du",
    "You and three competitors each receive 24,000 challenge coins and ten turns. Roll, then upgrade one landmark or save your coins. Every upgrade earns one point.": "Du und drei Konkurrenten erhalten jeweils 24.000 Herausforderungsmünzen und zehn Runden. Wirf und verbessere dann ein Wahrzeichen oder spare deine Münzen. Für jedes Upgrade erhalten Sie einen Punkt.",
    "You keep your {rolls} regular rolls and {turns} remaining challenge turns.": "Du behältst deine regulären {rolls} -Würfe und deine {turns} verbleibenden Herausforderungsrunden.",
    "You need more challenge coins for that upgrade.": "Für dieses Upgrade benötigst du mehr Challenge-Münzen.",
    "You rolled {dice} and earned {coins} challenge coins.": "Du hast {dice} gewürfelt und {coins} Challenge-Münzen verdient.",
    "You rolled {v0}. Choose Build or Save below to finish your turn. All three opponents go next.": "Du hast {v0} gewürfelt. Wähle unten „Bauen“ oder „Speichern“, um deinen Zug zu beenden. Alle drei Gegner sind als Nächstes dran.",
    "You saved your coins and continued to the next roll.": "Sie haben Ihre Münzen gespeichert und sind mit dem nächsten Wurf fortgefahren.",
    "You saved your coins for a future upgrade.": "Du hast deine Münzen für ein zukünftiges Upgrade gespeichert.",
    "You share first place!": "Ihr teilt euch den ersten Platz!",
    "You upgraded {landmark} to level {level}.": "Du hast {landmark} auf Level {level} hochgestuft.",
    "Your challenge changed in another window. The latest progress has been loaded.": "Ihre Herausforderung hat sich in einem anderen Fenster geändert. Der letzte Fortschritt wurde geladen.",
    "Your challenge city": "Deine Herausforderungsstadt",
    "Your challenge record": "Dein Challenge-Rekord",
    "Your challenge turn": "Deine Herausforderungsrunde",
    "Your city": "Deine Stadt",
    "Your opponents take their turns after either choice. Roll again to save automatically, let them play, then take your next roll.": "Deine Gegner sind nach jeder Wahl an der Reihe. Würfeln Sie erneut, um automatisch zu speichern, lassen Sie sie spielen und werfen Sie dann Ihren nächsten Wurf.",
    "Your regular city stays separate. Extra rolls from the Shop do not count here. Equal scores share the same place.": "Deine reguläre Stadt bleibt getrennt. Zusätzliche Rollen aus dem Shop zählen hier nicht. Gleiche Punkte teilen sich den gleichen Platz.",
    "Your skyline": "Deine Skyline",
    "Your skyline wins!": "Deine Skyline gewinnt!",
    "Your turn · rolling the dice…": "Du bist dran · würfeln...",
    "pts": "pts",
    "rolls remaining": "verbleibende Würfe",
    "{coins} challenge coins": "{coins} Herausforderungsmünzen",
    "{coins} challenge coins · Last dice {dice}": "{coins} Herausforderungsmünzen · Letzte Würfel {dice}",
    "{coins} coins": "{coins} -Münzen",
    "{count} challenge rounds left": "{count} Challenge-Runden übrig",
    "{language} challenge · {round} / 10 rounds complete": "{language} -Herausforderung · {round}/10 Runden abgeschlossen",
    "{name} rolled {dice}, earned {coins} coins, and saved for a future upgrade.": "{name} hat {dice} gewürfelt, {coins} -Münzen verdient und für ein zukünftiges Upgrade gespeichert.",
    "{name} rolled {dice}, earned {coins} coins, and upgraded {landmark} to level {level}.": "{name} hat {dice} gewürfelt, {coins} -Münzen verdient und {landmark} auf Level {level} hochgestuft.",
    "{points} points": "{points} Punkte",
    "{points} points · {coins} coins": "{points} Punkte · {coins} Münzen",
    "{rolls} ROLLS REMAINING": "{rolls} VERBLEIBENDE WÜRFE",
    "{v0} coins · Level {v1} → {v2}": "{v0} Münzen · Level {v1} → {v2}",
    "{v0} points · {v1} coins": "{v0} Punkte · {v1} Münzen",
    "{v0} · Level {v1} / 3": "{v0} · Stufe {v1}/3",
    "{v0}'s challenge city": "Die Herausforderungsstadt von {v0}",
    "{v0}’s skyline": "Die Skyline von {v0}",
    "← Back to your city": "← Zurück in deine Stadt",
    "◉ Speak": "▲ Sprich",
    "◉ Talk": "▲ Gespräch",
    "ADMIN ACCESS": "ADMIN-ZUGANG",
    "Adding…": "Wird hinzugefügt...",
    "Admin · Free": "Admin · Kostenlos",
    "Choose any roll package. No charge will be made.": "Wählen Sie ein beliebiges Rollenpaket. Es wird keine Gebühr erhoben.",
    "{rolls} rolls added at no charge.": "{rolls} Rollen werden kostenlos hinzugefügt.",
    "{rolls} ROLLS": "{rolls} WÜRFE"
  },
  "hi-IN": {
    "24,000 coins · 10 turns": "24,000 सिक्के · 10 मोड़",
    "3D city unavailable. Your buildings and scores are shown below.": "3D शहर अनुपलब्ध है। आपके भवन और स्कोर नीचे दिखाए गए हैं।",
    "A city worth building.": "एक शहर जो निर्माण के लायक है।",
    "A friendly race to the skyline.": "क्षितिज के लिए एक दोस्ताना दौड़।",
    "A request identifier is required.": "एक अनुरोध पहचानकर्ता आवश्यक है।",
    "AI PLAYER": "एआई प्लेयर",
    "AI competitor": "AI प्रतियोगी",
    "All three opponents finished round {round}.": "तीनों विरोधियों ने {round} राउंड समाप्त किया।",
    "An AI player, powered by Experts Alive. Conversations cannot spend coins or change the result.": "एक AI प्लेयर, जो Experts Alive द्वारा संचालित है। वार्तालाप सिक्के खर्च नहीं कर सकते हैं या परिणाम नहीं बदल सकते हैं।",
    "Ask": "पूछो",
    "Ask about their strategy": "उनकी रणनीति के बारे में पूछें",
    "Ask your competitor": "अपने प्रतियोगी से पूछें",
    "Available for the random draw": "रैंडम ड्रा के लिए उपलब्ध",
    "Balanced builder": "बैलेंस्ड बिल्डर",
    "Broadway House": "ब्रॉडवे हाउस",
    "Brooklyn Crossing": "ब्रुकलिन क्रॉसिंग",
    "Build": "बिल्ड करें",
    "Build & finish turn": "बिल्ड एंड फिनिश टर्न",
    "Build and finish challenge turn": "चैलेंज टर्न बनाएं और खत्म करें",
    "Build once or save": "एक बार बनाएं या सेव करें",
    "Buy more rolls": "और रोल खरीदें",
    "CHALLENGE CITY · NEW YORK": "चैलेंज सिटी · न्यू यॉर्क",
    "CONNECTING": "जोड़ने",
    "Central Gardens": "सेंट्रल गार्डन्स",
    "Challenge complete": "चुनौती पूरी",
    "Challenge controls": "चैलेंज नियंत्रण",
    "Challenge standings": "चैलेंज स्टैंडिंग",
    "Challenge · Round {v0} of 10": "चैलेंज · 10 का {v0} राउंड",
    "Challenge · {round} of 10 rounds complete": "चैलेंज · 10 राउंड में से {round} पूरे हुए",
    "Choose challenge landmark": "चैलेंज लैंडमार्क चुनें",
    "Choose one of the five landmarks.": "पांच स्थलों में से एक चुनें।",
    "Choose one of the thirteen supported languages.": "तेरह समर्थित भाषाओं में से एक चुनें।",
    "Choose your landmark · one upgrade earns one point": "अपना लैंडमार्क चुनें · एक अपग्रेड से एक पॉइंट मिलता है",
    "Close ×": "बंद करें ×",
    "Collect result": "परिणाम एकत्र करें",
    "Collect saves this result in your challenge record. No coins or paid rewards are awarded.": "कलेक्ट इस परिणाम को आपके चैलेंज रिकॉर्ड में सहेजता है। कोई सिक्के या सशुल्क पुरस्कार नहीं दिए जाते हैं।",
    "Complete": "पूरा करें",
    "Connect online to talk with your competitor.": "अपने प्रतियोगी से बात करने के लिए ऑनलाइन कनेक्ट करें।",
    "Connect to Lucky Estates online to save and play a challenge.": "एक चुनौती को बचाने और खेलने के लिए लकी एस्टेट से ऑनलाइन जुड़ें।",
    "DISCONNECTED": "डिस्कनेक्ट किया गया",
    "Discuss the match, compare strategies, or ask about this city.": "मैच पर चर्चा करें, रणनीतियों की तुलना करें या इस शहर के बारे में पूछें।",
    "ERROR": "ग़लती",
    "Entire city": "पूरा शहर",
    "Everyone starts on the same block.": "हर कोई एक ही ब्लॉक पर शुरू होता है।",
    "FINAL STANDINGS": "अंतिम स्टैंडिंग",
    "Finish your current challenge first.": "अपनी वर्तमान चुनौती को पहले समाप्त करें।",
    "First place: {names}. You earned {points} points.": "पहला स्थान: {names}। आपने {points} अंक अर्जित किए.",
    "Game restarted. Everyone keeps {count} remaining challenge turns; no rolls were added.": "खेल फिर से शुरू हुआ। हर कोई {count} शेष चैलेंज टर्न लेता है; कोई रोल नहीं जोड़ा गया।",
    "Game restarted. Your remaining rolls were preserved.": "खेल फिर से शुरू हुआ। आपके शेष रोल संरक्षित किए गए थे।",
    "Harbor Beacon": "हार्बर बीकन",
    "IDLE": "बेकार",
    "Keep playing": "बजाते रहो",
    "LISTENING": "सुन रहा है",
    "Latest moves": "नवीनतम चालें",
    "Level {level} / 3": "लेवल {level}/3",
    "Listening — ask your question.": "सुनना — अपना प्रश्न पूछें।",
    "Loading challenge…": "चुनौती लोड हो रही है...",
    "Loading…": "लोड हो रहा है...",
    "Meet your competitors": "अपने प्रतिस्पर्धियों से मिलें",
    "Next goal · Start a city challenge": "अगला लक्ष्य · शहर की चुनौती शुरू करें",
    "No new rolls are added. Your language, avatar, audio preferences, and previously collected gifts are kept.": "कोई नया रोल नहीं जोड़ा गया है। आपकी भाषा, अवतार, ऑडियो प्राथमिकताएं, और पहले एकत्र किए गए उपहार रखे जाते हैं।",
    "No purchases needed": "किसी खरीदारी की जरूरत नहीं",
    "Not enough coins for an upgrade": "अपग्रेड के लिए पर्याप्त सिक्के नहीं",
    "Opponent language: {language}": "विरोधी भाषा: {language}",
    "Opponents completed their turns": "विरोधियों ने अपनी बारी पूरी की",
    "Optional visits and conversations. Your Lucky guide remains available through Explain this.": "वैकल्पिक विज़िट और वार्तालाप। इस बारे में बताओ के माध्यम से आपकी लकी गाइड उपलब्ध रहती है।",
    "Or Roll to save and continue automatically.": "या स्वचालित रूप से सहेजने और जारी रखने के लिए रोल करें।",
    "PLAYERS · CITY CHALLENGE": "खिलाड़ी · सिटी चैलेंज",
    "Place {place} · {points} points": "{place} को जगह दें · {points} पॉइंट",
    "Play with {language} opponents": "{language} विरोधियों के साथ खेलें",
    "Players": "प्लेयर्स",
    "Players ↗": "प्लेयर्स ↗",
    "Prefer to keep your coins?": "अपने सिक्के रखना पसंद करते हैं?",
    "Quick builder": "क्विक बिल्डर",
    "READY": "तैयार",
    "ROUND {round}": "राऊंड {round}",
    "Reconnect": "फिर से कनेक्ट करें",
    "Reload progress": "प्रगति को फिर से लोड करें",
    "Restart Game": "खेल को पुनः आरंभ करें",
    "Restart Game?": "खेल को फिर से शुरू करें?",
    "Restarting…": "पुनः आरंभ किया जा रहा है...",
    "Rivals take their turns": "प्रतिद्वंद्वी अपनी बारी लेते हैं",
    "Roll again · auto-save coins": "फिर से रोल करें · सिक्कों को ऑटो-सेव करें",
    "Roll before choosing a building or saving.": "बिल्डिंग चुनने या सेविंग करने से पहले रोल करें।",
    "Roll challenge dice": "रोल चैलेंज पासा",
    "Roll for coins": "सिक्कों के लिए रोल",
    "Roll here or use the orange Roll button on Play to take your challenge turn.": "अपनी चुनौती को मोड़ने के लिए यहां रोल करें या प्ले पर नारंगी रोल बटन का उपयोग करें।",
    "Roll, then choose Build or Save above the Roll button.": "रोल करें, फिर रोल बटन के ऊपर बिल्ड या सेव चुनें।",
    "SPEAKING": "बोल रहा हूँ",
    "Save coins": "सिक्के बचाओ",
    "Save coins & finish turn →": "सिक्के बचाओ और बारी खत्म करो →",
    "Save coins and finish challenge turn": "सिक्के बचाएं और चैलेंज टर्न खत्म करें",
    "Save coins for your next upgrade": "अपने अगले अपग्रेड के लिए सिक्के सहेजें",
    "Save your regular game successfully before restarting. Reload if another window changed your game.": "पुनः आरंभ करने से पहले अपने नियमित गेम को सफलतापूर्वक सहेजें। अगर किसी अन्य विंडो ने आपका गेम बदल दिया है, तो फिर से लोड करें।",
    "Saving your coins. Opponents take their turns first…": "अपने सिक्कों को सहेजना। विरोधी पहले अपनी बारी लेते हैं...",
    "Saving your move and updating the challenge…": "अपनी चाल सहेज रहा है और चुनौती को अपडेट कर रहा है...",
    "Saving…": "सहेज रहा है...",
    "Select a landmark to look closer": "करीब से देखने के लिए एक लैंडमार्क चुनें",
    "Setting up your city…": "अपना शहर सेट किया जा रहा है...",
    "Skyline Tower": "स्काईलाइन टावर",
    "Start 10-turn challenge": "10-टर्न चैलेंज शुरू करें",
    "Start 10-turn challenge →": "10-टर्न चैलेंज शुरू करें →",
    "Start another challenge": "एक और चुनौती शुरू करें",
    "Stop the response and turn on your microphone.": "प्रतिक्रिया रोकें और अपने माइक्रोफ़ोन को चालू करें।",
    "THE TEN-TURN CITY CHALLENGE": "दस मोड़ वाली शहर की चुनौती",
    "THINKING": "सोच",
    "Talk with {name}": "{name} के साथ बात करें",
    "The challenge could not be loaded. Try again.": "चुनौती को लोड नहीं किया जा सका। फिर से कोशिश करें।",
    "The conversation was interrupted. Your challenge is saved; reconnect when ready.": "बातचीत बाधित हुई। आपकी चुनौती सहेज ली गई है; तैयार होने पर फिर से कनेक्ट करें।",
    "The restart could not be completed. Close this panel, reload progress, and try again.": "पुनः आरंभ पूरा नहीं किया जा सका। इस पैनल को बंद करें, प्रगति को फिर से लोड करें, और फिर से कोशिश करें।",
    "The results are saved. Equal scores share a place.": "परिणाम सहेजे गए हैं। समान स्कोर किसी स्थान को साझा करते हैं।",
    "There is no new result to collect.": "इकट्ठा करने के लिए कोई नया परिणाम नहीं है।",
    "This challenge is complete.": "यह चुनौती पूरी हो गई है।",
    "This challenge is no longer current.": "यह चुनौती अब मौजूदा नहीं है।",
    "This challenge keeps its {language} opponents and progress. Your next challenge or an explicit Restart Game will use {next}.": "यह चुनौती अपने {language} विरोधियों और प्रगति को बनाए रखती है। आपकी अगली चुनौती या एक स्पष्ट रीस्टार्ट गेम {next} का उपयोग करेगा।",
    "This landmark is already complete.": "यह लैंडमार्क पहले ही पूरा हो चुका है।",
    "This resets your regular city and challenge buildings, scores, and coins. Three competitors will be chosen at random again.": "यह आपके नियमित शहर को रीसेट करता है और इमारतों, स्कोर और सिक्कों को चुनौती देता है। तीन प्रतियोगियों को फिर से यादृच्छिक रूप से चुना जाएगा।",
    "Three AI city builders. Ten turns. Your next great neighborhood.": "तीन एआई सिटी बिल्डर्स। दस मोड़। आपका अगला शानदार पड़ोस।",
    "Three competitors are chosen at random from the six who speak your selected language.": "आपकी चुनी हुई भाषा बोलने वाले छह प्रतियोगियों में से तीन प्रतियोगियों को यादृच्छिक रूप से चुना जाता है।",
    "Tower specialist": "टावर स्पेशलिस्ट",
    "Turn {v0} of 10": "10 का {v0} चालू करें",
    "Unknown challenge action.": "अज्ञात चुनौती कार्रवाई।",
    "Updating your challenge…": "अपनी चुनौती को अपडेट कर रहा है...",
    "View challenge results": "चुनौती के परिणाम देखें",
    "Visit city": "शहर की सैर करें",
    "Visiting {v0}": "{v0} पर जाना",
    "Wait for the current response, or press Speak to interrupt.": "मौजूदा प्रतिक्रिया की प्रतीक्षा करें, या बीच में आने के लिए बोलें दबाएँ।",
    "YOU": "आप",
    "YOUR MOVE": "आपकी चाल",
    "You": "आप",
    "You and three competitors each receive 24,000 challenge coins and ten turns. Roll, then upgrade one landmark or save your coins. Every upgrade earns one point.": "आप और तीन प्रतियोगियों में से प्रत्येक को 24,000 चैलेंज कॉइन और दस टर्न मिलते हैं। रोल करें, फिर एक लैंडमार्क अपग्रेड करें या अपने सिक्कों को सेव करें। हर अपग्रेड से एक पॉइंट मिलता है।",
    "You keep your {rolls} regular rolls and {turns} remaining challenge turns.": "आप अपने {rolls} नियमित रोल और {turns} शेष चैलेंज को चालू रखते हैं.",
    "You need more challenge coins for that upgrade.": "उस अपग्रेड के लिए आपको अधिक चुनौती वाले सिक्कों की आवश्यकता है।",
    "You rolled {dice} and earned {coins} challenge coins.": "आपने {dice} रोल किया और {coins} चैलेंज सिक्के अर्जित किए।",
    "You rolled {v0}. Choose Build or Save below to finish your turn. All three opponents go next.": "आपने {v0} को रोल किया। अपनी बारी पूरी करने के लिए नीचे बिल्ड या सेव चुनें। इसके बाद तीनों प्रतिद्वंद्वी आगे बढ़ते हैं।",
    "You saved your coins and continued to the next roll.": "आपने अपने सिक्के सहेजे और अगले रोल तक जारी रखा।",
    "You saved your coins for a future upgrade.": "आपने भविष्य के अपग्रेड के लिए अपने सिक्के सहेजे हैं।",
    "You share first place!": "आप पहला स्थान साझा करते हैं!",
    "You upgraded {landmark} to level {level}.": "आपने {landmark} को {level} स्तर पर अपग्रेड किया है।",
    "Your challenge changed in another window. The latest progress has been loaded.": "आपकी चुनौती दूसरी विंडो में बदल गई। नवीनतम प्रगति लोड हो गई है।",
    "Your challenge city": "आपका चैलेंज सिटी",
    "Your challenge record": "आपका चैलेंज रिकॉर्ड",
    "Your challenge turn": "आपकी चुनौती की बारी",
    "Your city": "आपका शहर",
    "Your opponents take their turns after either choice. Roll again to save automatically, let them play, then take your next roll.": "आपके विरोधी किसी भी विकल्प के बाद अपनी बारी लेते हैं। स्वचालित रूप से सेव करने के लिए फिर से रोल करें, उन्हें खेलने दें, फिर अपना अगला रोल लें।",
    "Your regular city stays separate. Extra rolls from the Shop do not count here. Equal scores share the same place.": "आपका नियमित शहर अलग रहता है। दुकान से मिलने वाले अतिरिक्त रोल की यहाँ गिनती नहीं की जाती है। समान स्कोर समान स्थान साझा करते हैं।",
    "Your skyline": "आपका स्काईलाइन",
    "Your skyline wins!": "आपका स्काईलाइन जीतता है!",
    "Your turn · rolling the dice…": "आपकी बारी · पासा पलटना...",
    "pts": "पीटीएस",
    "rolls remaining": "पासा चालें शेष",
    "{coins} challenge coins": "{coins} चैलेंज सिक्के",
    "{coins} challenge coins · Last dice {dice}": "{coins} चुनौती के सिक्के · आखिरी पासा {dice}",
    "{coins} coins": "{coins} के सिक्के",
    "{count} challenge rounds left": "{count} चैलेंज राउंड बचे हैं",
    "{language} challenge · {round} / 10 rounds complete": "{language} चैलेंज · {round} /10 राउंड पूरे हुए",
    "{name} rolled {dice}, earned {coins} coins, and saved for a future upgrade.": "{name} ने {dice} को रोल किया, {coins} सिक्के कमाए, और भविष्य के अपग्रेड के लिए सेव किया।",
    "{name} rolled {dice}, earned {coins} coins, and upgraded {landmark} to level {level}.": "{name} ने {dice} को रोल किया, {coins} सिक्के कमाए, और {landmark} को {level} के स्तर पर अपग्रेड किया।",
    "{points} points": "{points} पॉइंट्स",
    "{points} points · {coins} coins": "{points} अंक · {coins} सिक्के",
    "{rolls} ROLLS REMAINING": "{rolls} पासा चालें शेष",
    "{v0} coins · Level {v1} → {v2}": "{v0} सिक्के · स्तर {v1} → {v2}",
    "{v0} points · {v1} coins": "{v0} अंक · {v1} सिक्के",
    "{v0} · Level {v1} / 3": "{v0} · लेवल {v1}/3",
    "{v0}'s challenge city": "{v0} की चैलेंज सिटी",
    "{v0}’s skyline": "{v0} का स्काईलाइन",
    "← Back to your city": "← अपने शहर में वापस जाएं",
    "◉ Speak": "◉ बोलो",
    "◉ Talk": "◉ वार्ता",
    "ADMIN ACCESS": "एडमिन ऐक्सेस",
    "Adding…": "जोड़ रहा है...",
    "Admin · Free": "Admin · नि:शुल्क",
    "Choose any roll package. No charge will be made.": "कोई भी रोल पैकेज चुनें। कोई शुल्क नहीं लिया जाएगा।",
    "{rolls} rolls added at no charge.": "{rolls} रोल बिना किसी शुल्क के जोड़े गए.",
    "{rolls} ROLLS": "{rolls} पासा चालें"
  },
  "id-ID": {
    "24,000 coins · 10 turns": "24.000 koin · 10 putaran",
    "3D city unavailable. Your buildings and scores are shown below.": "Kota 3D tidak tersedia. Bangunan dan skor Anda ditunjukkan di bawah ini.",
    "A city worth building.": "Kota yang layak dibangun",
    "A friendly race to the skyline.": "Perlombaan persahabatan menuju cakrawala.",
    "A request identifier is required.": "Pengidentifikasi permintaan diperlukan.",
    "AI PLAYER": "PEMAIN AI",
    "AI competitor": "Pesaing AI",
    "All three opponents finished round {round}.": "Ketiga lawan menyelesaikan ronde {round}.",
    "An AI player, powered by Experts Alive. Conversations cannot spend coins or change the result.": "Pemain AI, didukung oleh Experts Alive. Percakapan tidak dapat menghabiskan koin atau mengubah hasilnya.",
    "Ask": "Tanya",
    "Ask about their strategy": "Tanyakan tentang strategi mereka",
    "Ask your competitor": "Tanyakan pesaing Anda",
    "Available for the random draw": "Tersedia untuk undian acak",
    "Balanced builder": "Pembangun seimbang",
    "Broadway House": "Rumah Broadway",
    "Brooklyn Crossing": "Persimpangan Brooklyn",
    "Build": "Membangun",
    "Build & finish turn": "Bangun & selesaikan belokan",
    "Build and finish challenge turn": "Bangun dan selesaikan putaran tantangan",
    "Build once or save": "Bangun sekali atau simpan",
    "Buy more rolls": "Beli lebih banyak gulungan",
    "CHALLENGE CITY · NEW YORK": "KOTA TANTANGAN · NEW YORK",
    "CONNECTING": "MENGHUBUNGKAN",
    "Central Gardens": "Taman Pusat",
    "Challenge complete": "Tantangan selesai",
    "Challenge controls": "Kontrol tantangan",
    "Challenge standings": "Tantangan klasemen",
    "Challenge · Round {v0} of 10": "Tantangan · Ronde {v0} dari 10",
    "Challenge · {round} of 10 rounds complete": "Tantangan · {round} dari 10 putaran selesai",
    "Choose challenge landmark": "Pilih landmark tantangan",
    "Choose one of the five landmarks.": "Pilih salah satu dari lima landmark.",
    "Choose one of the thirteen supported languages.": "Pilih salah satu dari tiga belas bahasa yang didukung.",
    "Choose your landmark · one upgrade earns one point": "Pilih landmark Anda · satu peningkatan menghasilkan satu poin",
    "Close ×": "Tutup ×",
    "Collect result": "Kumpulkan hasil",
    "Collect saves this result in your challenge record. No coins or paid rewards are awarded.": "Kumpulkan menyimpan hasil ini dalam catatan tantangan Anda. Tidak ada koin atau hadiah berbayar yang diberikan.",
    "Complete": "Lengkap",
    "Connect online to talk with your competitor.": "Terhubung secara online untuk berbicara dengan pesaing Anda.",
    "Connect to Lucky Estates online to save and play a challenge.": "Terhubung ke Lucky Estates online untuk menyimpan dan memainkan tantangan.",
    "DISCONNECTED": "TERPUTUS",
    "Discuss the match, compare strategies, or ask about this city.": "Diskusikan pertandingan, bandingkan strategi, atau tanyakan tentang kota ini.",
    "ERROR": "KESALAHAN",
    "Entire city": "Seluruh kota",
    "Everyone starts on the same block.": "Semua orang mulai di blok yang sama.",
    "FINAL STANDINGS": "KLASEMEN AKHIR",
    "Finish your current challenge first.": "Selesaikan tantangan Anda saat ini terlebih dahulu.",
    "First place: {names}. You earned {points} points.": "Tempat pertama: {names}. Anda mendapatkan poin {points}.",
    "Game restarted. Everyone keeps {count} remaining challenge turns; no rolls were added.": "Permainan dimulai ulang. Semua orang mempertahankan putaran tantangan {count} yang tersisa; tidak ada gulungan yang ditambahkan.",
    "Game restarted. Your remaining rolls were preserved.": "Permainan dimulai ulang. Gulungan Anda yang tersisa diawetkan.",
    "Harbor Beacon": "Suar Pelabuhan",
    "IDLE": "MENGANGGUR",
    "Keep playing": "Terus bermain",
    "LISTENING": "MENDENGARKAN",
    "Latest moves": "Gerakan terbaru",
    "Level {level} / 3": "Tingkat {level}/3",
    "Listening — ask your question.": "Mendengarkan - ajukan pertanyaan Anda.",
    "Loading challenge…": "Memuat tantangan...",
    "Loading…": "Memuat...",
    "Meet your competitors": "Temui pesaing Anda",
    "Next goal · Start a city challenge": "Tujuan berikutnya · Mulai tantangan kota",
    "No new rolls are added. Your language, avatar, audio preferences, and previously collected gifts are kept.": "Tidak ada gulungan baru yang ditambahkan. Bahasa, avatar, preferensi audio, dan hadiah yang dikumpulkan sebelumnya disimpan.",
    "No purchases needed": "Tidak perlu pembelian",
    "Not enough coins for an upgrade": "Tidak cukup koin untuk upgrade",
    "Opponent language: {language}": "Bahasa lawan: {language}",
    "Opponents completed their turns": "Lawan menyelesaikan giliran mereka",
    "Optional visits and conversations. Your Lucky guide remains available through Explain this.": "Kunjungan dan percakapan opsional. Panduan Keberuntungan Anda tetap tersedia melalui Jelaskan ini.",
    "Or Roll to save and continue automatically.": "Atau Gulung untuk menyimpan dan melanjutkan secara otomatis.",
    "PLAYERS · CITY CHALLENGE": "PEMAIN · TANTANGAN KOTA",
    "Place {place} · {points} points": "Tempat {place} · {points} poin",
    "Play with {language} opponents": "Bermain dengan lawan {language}",
    "Players": "Pemain",
    "Players ↗": "Pemain ↗",
    "Prefer to keep your coins?": "Lebih suka menyimpan koin Anda?",
    "Quick builder": "Pembangun cepat",
    "READY": "SIAP",
    "ROUND {round}": "RONDE {round}",
    "Reconnect": "Sambungkan kembali",
    "Reload progress": "Muat ulang kemajuan",
    "Restart Game": "Mulai Ulang Permainan",
    "Restart Game?": "Mulai Ulang Game?",
    "Restarting…": "Memulai ulang...",
    "Rivals take their turns": "Saingan bergiliran",
    "Roll again · auto-save coins": "Gulung lagi · simpan koin secara otomatis",
    "Roll before choosing a building or saving.": "Gulung sebelum memilih bangunan atau menabung.",
    "Roll challenge dice": "Melempar dadu tantangan",
    "Roll for coins": "Gulung untuk koin",
    "Roll here or use the orange Roll button on Play to take your challenge turn.": "Gulung di sini atau gunakan tombol Roll oranye di Play untuk mengambil giliran tantangan Anda.",
    "Roll, then choose Build or Save above the Roll button.": "Gulung, lalu pilih Build atau Save di atas tombol Roll.",
    "SPEAKING": "BERBICARA",
    "Save coins": "Simpan koin",
    "Save coins & finish turn →": "Simpan koin & selesaikan giliran →",
    "Save coins and finish challenge turn": "Simpan koin dan selesaikan putaran tantangan",
    "Save coins for your next upgrade": "Simpan koin untuk upgrade Anda berikutnya",
    "Save your regular game successfully before restarting. Reload if another window changed your game.": "Simpan game reguler Anda dengan sukses sebelum memulai ulang. Muat ulang jika jendela lain mengubah permainan Anda.",
    "Saving your coins. Opponents take their turns first…": "Menyimpan koin Anda. Lawan mengambil giliran terlebih dahulu...",
    "Saving your move and updating the challenge…": "Menyimpan langkah Anda dan memperbarui tantangan...",
    "Saving…": "Menyimpan...",
    "Select a landmark to look closer": "Pilih landmark untuk melihat lebih dekat",
    "Setting up your city…": "Menyiapkan kota Anda...",
    "Skyline Tower": "Menara Skyline",
    "Start 10-turn challenge": "Mulai tantangan 10 putaran",
    "Start 10-turn challenge →": "Mulai tantangan 10 putaran →",
    "Start another challenge": "Mulai tantangan lain",
    "Stop the response and turn on your microphone.": "Hentikan respons dan nyalakan mikrofon Anda.",
    "THE TEN-TURN CITY CHALLENGE": "TANTANGAN KOTA SEPULUH PUTARAN",
    "THINKING": "BERPIKIR",
    "Talk with {name}": "Bicaralah dengan {name}",
    "The challenge could not be loaded. Try again.": "Tantangan tidak bisa dimuat. Coba lagi.",
    "The conversation was interrupted. Your challenge is saved; reconnect when ready.": "Percakapan itu terputus. Tantangan Anda disimpan; sambungkan kembali saat siap.",
    "The restart could not be completed. Close this panel, reload progress, and try again.": "Restart tidak dapat diselesaikan. Tutup panel ini, muat ulang progres, dan coba lagi.",
    "The results are saved. Equal scores share a place.": "Hasilnya disimpan. Skor yang sama berbagi tempat.",
    "There is no new result to collect.": "Tidak ada hasil baru untuk dikumpulkan.",
    "This challenge is complete.": "Tantangan ini selesai.",
    "This challenge is no longer current.": "Tantangan ini sudah tidak ada lagi.",
    "This challenge keeps its {language} opponents and progress. Your next challenge or an explicit Restart Game will use {next}.": "Tantangan ini menjaga lawan dan kemajuan {language}. Tantangan Anda berikutnya atau Game Restart eksplisit akan menggunakan {next}.",
    "This landmark is already complete.": "Landmark ini sudah selesai.",
    "This resets your regular city and challenge buildings, scores, and coins. Three competitors will be chosen at random again.": "Ini mengatur ulang kota reguler Anda dan menantang bangunan, skor, dan koin. Tiga pesaing akan dipilih secara acak lagi.",
    "Three AI city builders. Ten turns. Your next great neighborhood.": "Tiga pembangun kota AI. Sepuluh putaran. Lingkungan besar Anda berikutnya.",
    "Three competitors are chosen at random from the six who speak your selected language.": "Tiga pesaing dipilih secara acak dari enam yang berbicara bahasa pilihan Anda.",
    "Tower specialist": "Spesialis menara",
    "Turn {v0} of 10": "Putar {v0} dari 10",
    "Unknown challenge action.": "Tindakan tantangan yang tidak diketahui.",
    "Updating your challenge…": "Memperbarui tantangan Anda...",
    "View challenge results": "Lihat hasil tantangan",
    "Visit city": "Kunjungi kota",
    "Visiting {v0}": "Mengunjungi {v0}",
    "Wait for the current response, or press Speak to interrupt.": "Tunggu respon saat ini, atau tekan Bicara untuk menyela.",
    "YOU": "KAMU",
    "YOUR MOVE": "LANGKAH ANDA",
    "You": "Anda",
    "You and three competitors each receive 24,000 challenge coins and ten turns. Roll, then upgrade one landmark or save your coins. Every upgrade earns one point.": "Anda dan tiga pesaing masing-masing menerima 24.000 koin tantangan dan sepuluh putaran. Gulung, lalu tingkatkan satu landmark atau simpan koin Anda. Setiap upgrade menghasilkan satu poin.",
    "You keep your {rolls} regular rolls and {turns} remaining challenge turns.": "Anda mempertahankan gulungan reguler {rolls} dan putaran tantangan {turns} yang tersisa.",
    "You need more challenge coins for that upgrade.": "Anda membutuhkan lebih banyak koin tantangan untuk peningkatan itu.",
    "You rolled {dice} and earned {coins} challenge coins.": "Anda menggulung {dice} dan mendapatkan koin tantangan {coins}.",
    "You rolled {v0}. Choose Build or Save below to finish your turn. All three opponents go next.": "Anda menggulung {v0}. Pilih Bangun atau Simpan di bawah ini untuk menyelesaikan giliran Anda. Ketiga lawan selanjutnya.",
    "You saved your coins and continued to the next roll.": "Anda menyimpan koin Anda dan melanjutkan ke gulungan berikutnya.",
    "You saved your coins for a future upgrade.": "Anda menyimpan koin Anda untuk peningkatan di masa mendatang.",
    "You share first place!": "Anda berbagi tempat pertama!",
    "You upgraded {landmark} to level {level}.": "Anda meningkatkan {landmark} ke level {level}.",
    "Your challenge changed in another window. The latest progress has been loaded.": "Tantangan Anda berubah di jendela lain. Kemajuan terbaru telah dimuat.",
    "Your challenge city": "Kota tantangan Anda",
    "Your challenge record": "Catatan tantangan Anda",
    "Your challenge turn": "Tantangan Anda giliran",
    "Your city": "Kota Anda",
    "Your opponents take their turns after either choice. Roll again to save automatically, let them play, then take your next roll.": "Lawan Anda bergiliran setelah salah satu pilihan. Gulung lagi untuk menyimpan secara otomatis, biarkan mereka bermain, lalu ambil gulungan Anda berikutnya.",
    "Your regular city stays separate. Extra rolls from the Shop do not count here. Equal scores share the same place.": "Kota reguler Anda tetap terpisah. Gulungan tambahan dari Toko tidak dihitung di sini. Skor yang sama berbagi tempat yang sama.",
    "Your skyline": "Cakrawala Anda",
    "Your skyline wins!": "Cakrawala Anda menang!",
    "Your turn · rolling the dice…": "Giliran Anda · melempar dadu...",
    "pts": "poin",
    "rolls remaining": "lemparan tersisa",
    "{coins} challenge coins": "Koin tantangan {coins}",
    "{coins} challenge coins · Last dice {dice}": "Koin tantangan {coins} · Dadu terakhir {dice}",
    "{coins} coins": "{coins} koin",
    "{count} challenge rounds left": "Putaran tantangan {count} tersisa",
    "{language} challenge · {round} / 10 rounds complete": "Tantangan {language} · {round}/10 putaran selesai",
    "{name} rolled {dice}, earned {coins} coins, and saved for a future upgrade.": "{name} menggulung {dice}, mendapatkan koin {coins}, dan disimpan untuk peningkatan di masa mendatang.",
    "{name} rolled {dice}, earned {coins} coins, and upgraded {landmark} to level {level}.": "{name} menggulung {dice}, mendapatkan {coins} koin, dan meningkatkan {landmark} ke level {level}.",
    "{points} points": "{points} poin",
    "{points} points · {coins} coins": "{points} poin · {coins} koin",
    "{rolls} ROLLS REMAINING": "{rolls} LEMPARAN TERSISA",
    "{v0} coins · Level {v1} → {v2}": "{v0} koin · Level {v1} → {v2}",
    "{v0} points · {v1} coins": "{v0} poin · {v1} koin",
    "{v0} · Level {v1} / 3": "{v0} · Tingkat {v1}/3",
    "{v0}'s challenge city": "Kota tantangan {v0}",
    "{v0}’s skyline": "Cakrawala {v0}",
    "← Back to your city": "← Kembali ke kota Anda",
    "◉ Speak": "◉ Bicara",
    "◉ Talk": "◉ Bicara",
    "Adding…": "Menambahkan...",
    "Admin · Free": "Admin · Gratis",
    "Choose any roll package. No charge will be made.": "Pilih paket gulungan apa saja. Tidak ada biaya yang akan dikenakan.",
    "ADMIN ACCESS": "AKSES ADMIN",
    "{rolls} rolls added at no charge.": "Gulungan {rolls} ditambahkan tanpa biaya.",
    "{rolls} ROLLS": "{rolls} LEMPARAN"
  },
  "it-IT": {
    "24,000 coins · 10 turns": "24.000 monete · 10 turni",
    "3D city unavailable. Your buildings and scores are shown below.": "Città 3D non disponibile. I tuoi edifici e i tuoi punteggi sono mostrati di seguito.",
    "A city worth building.": "Una città che vale la pena costruire.",
    "A friendly race to the skyline.": "Una corsa amichevole verso l'orizzonte.",
    "A request identifier is required.": "È richiesto un identificativo della richiesta.",
    "AI PLAYER": "GIOCATORE DI INTELLIGENZA ARTIFICIALE",
    "AI competitor": "Concorrente AI",
    "All three opponents finished round {round}.": "Tutti e tre gli avversari hanno concluso il round {round}.",
    "An AI player, powered by Experts Alive. Conversations cannot spend coins or change the result.": "Un giocatore di intelligenza artificiale, potenziato da Experts Alive. Le conversazioni non possono spendere monete o modificare il risultato.",
    "Ask": "Chiedere",
    "Ask about their strategy": "Chiedi informazioni sulla loro strategia",
    "Ask your competitor": "Chiedi al tuo concorrente",
    "Available for the random draw": "Disponibile per l'estrazione casuale",
    "Balanced builder": "Costruttore bilanciato",
    "Broadway House": "Casa di Broadway",
    "Brooklyn Crossing": "Attraversamento di Brooklyn",
    "Build": "Costruisci",
    "Build & finish turn": "Costruisci e completa il turno",
    "Build and finish challenge turn": "Costruisci e completa il turno della sfida",
    "Build once or save": "Costruisci una volta o salva",
    "Buy more rolls": "Acquista altri rotoli",
    "CHALLENGE CITY · NEW YORK": "CHALLENGE CITY · NEW YORK",
    "CONNECTING": "CONNETTENDO",
    "Central Gardens": "Giardini centrali",
    "Challenge complete": "Sfida completata",
    "Challenge controls": "Controlli delle sfide",
    "Challenge standings": "Classifica della sfida",
    "Challenge · Round {v0} of 10": "Sfida · Turno {v0} di 10",
    "Challenge · {round} of 10 rounds complete": "Sfida · {round} di 10 round completati",
    "Choose challenge landmark": "Scegli il punto di riferimento della sfida",
    "Choose one of the five landmarks.": "Scegli uno dei cinque punti di riferimento.",
    "Choose one of the thirteen supported languages.": "Scegli una delle tredici lingue supportate.",
    "Choose your landmark · one upgrade earns one point": "Scegli il tuo punto di riferimento · un upgrade fa guadagnare un punto",
    "Close ×": "Chiudi ×",
    "Collect result": "Raccogli i risultati",
    "Collect saves this result in your challenge record. No coins or paid rewards are awarded.": "Collect salva questo risultato nel record delle tue sfide. Non vengono assegnate monete o ricompense a pagamento.",
    "Complete": "Completo",
    "Connect online to talk with your competitor.": "Connettiti online per parlare con il tuo concorrente.",
    "Connect to Lucky Estates online to save and play a challenge.": "Connettiti a Lucky Estates online per salvare e giocare una sfida.",
    "DISCONNECTED": "DISCONNESSO",
    "Discuss the match, compare strategies, or ask about this city.": "Discutete della partita, confrontate le strategie o chiedete informazioni su questa città.",
    "ERROR": "ERRORE",
    "Entire city": "Città intera",
    "Everyone starts on the same block.": "Tutti iniziano dallo stesso blocco.",
    "FINAL STANDINGS": "CLASSIFICA FINALE",
    "Finish your current challenge first.": "Completa prima la tua sfida attuale.",
    "First place: {names}. You earned {points} points.": "Primo posto: {names}. Hai guadagnato {points} punti.",
    "Game restarted. Everyone keeps {count} remaining challenge turns; no rolls were added.": "Il gioco è stato riavviato. Tutti mantengono i {count} turni di sfida rimanenti; non è stato aggiunto alcun turno.",
    "Game restarted. Your remaining rolls were preserved.": "Il gioco è stato riavviato. I rulli rimanenti sono stati conservati.",
    "Harbor Beacon": "Faro del porto",
    "IDLE": "INATTIVO",
    "Keep playing": "Continua a giocare",
    "LISTENING": "ASCOLTO",
    "Latest moves": "Ultime mosse",
    "Level {level} / 3": "Livello {level}/3",
    "Listening — ask your question.": "Ascolto: fai la tua domanda.",
    "Loading challenge…": "Sfida di caricamento...",
    "Loading…": "Caricamento...",
    "Meet your competitors": "Incontra i tuoi concorrenti",
    "Next goal · Start a city challenge": "Prossimo obiettivo · Inizia una sfida in città",
    "No new rolls are added. Your language, avatar, audio preferences, and previously collected gifts are kept.": "Non vengono aggiunti nuovi rotoli. La lingua, l'avatar, le preferenze audio e i regali raccolti in precedenza vengono mantenuti.",
    "No purchases needed": "Non sono necessari acquisti",
    "Not enough coins for an upgrade": "Non ci sono abbastanza monete per un upgrade",
    "Opponent language: {language}": "Lingua dell'avversario: {language}",
    "Opponents completed their turns": "Gli avversari hanno completato i loro turni",
    "Optional visits and conversations. Your Lucky guide remains available through Explain this.": "Visite e conversazioni opzionali. La tua guida Lucky rimane disponibile tramite Explain this.",
    "Or Roll to save and continue automatically.": "Oppure Roll per salvare e continuare automaticamente.",
    "PLAYERS · CITY CHALLENGE": "GIOCATORI · SFIDA IN CITTÀ",
    "Place {place} · {points} points": "Luogo {place} · {points} punti",
    "Play with {language} opponents": "Gioca con gli avversari {language}",
    "Players": "Giocatori",
    "Players ↗": "Giocatori ↗",
    "Prefer to keep your coins?": "Preferisci conservare le tue monete?",
    "Quick builder": "Costruttore rapido",
    "READY": "PRONTO",
    "ROUND {round}": "TURNO {round}",
    "Reconnect": "Riconnetti",
    "Reload progress": "Avanzamento del ricaricamento",
    "Restart Game": "Riavvia il gioco",
    "Restart Game?": "Riavviare il gioco?",
    "Restarting…": "Riavvio in corso...",
    "Rivals take their turns": "I rivali fanno il loro turno",
    "Roll again · auto-save coins": "Roll again · salva automaticamente le monete",
    "Roll before choosing a building or saving.": "Rotola prima di scegliere un edificio o risparmiare.",
    "Roll challenge dice": "Lancia i dadi della sfida",
    "Roll for coins": "Rotolo per monete",
    "Roll here or use the orange Roll button on Play to take your challenge turn.": "Tira qui o usa il pulsante arancione Roll su Gioca per completare il tuo turno di sfida.",
    "Roll, then choose Build or Save above the Roll button.": "Tira, quindi scegli Crea o Salva sopra il pulsante Rolla.",
    "SPEAKING": "PARLANDO",
    "Save coins": "Risparmia monete",
    "Save coins & finish turn →": "Salva monete e termina il turno →",
    "Save coins and finish challenge turn": "Risparmia monete e completa il turno di sfida",
    "Save coins for your next upgrade": "Risparmia monete per il tuo prossimo aggiornamento",
    "Save your regular game successfully before restarting. Reload if another window changed your game.": "Salva la tua partita normale con successo prima di riavviarla. Ricarica se un'altra finestra ha cambiato il gioco.",
    "Saving your coins. Opponents take their turns first…": "Salvare le tue monete. Gli avversari fanno il loro turno per primi...",
    "Saving your move and updating the challenge…": "Salvare la mossa e aggiornare la sfida...",
    "Saving…": "Salvataggio...",
    "Select a landmark to look closer": "Seleziona un punto di riferimento per guardare più da vicino",
    "Setting up your city…": "Configurare la tua città...",
    "Skyline Tower": "Torre Skyline",
    "Start 10-turn challenge": "Inizia una sfida a 10 turni",
    "Start 10-turn challenge →": "Inizia una sfida a 10 turni →",
    "Start another challenge": "Inizia un'altra sfida",
    "Stop the response and turn on your microphone.": "Interrompi la risposta e accendi il microfono.",
    "THE TEN-TURN CITY CHALLENGE": "LA SFIDA DELLA CITTÀ IN DIECI TURNI",
    "THINKING": "PENSANDO",
    "Talk with {name}": "Parla con {name}",
    "The challenge could not be loaded. Try again.": "La sfida non può essere caricata. Riprova.",
    "The conversation was interrupted. Your challenge is saved; reconnect when ready.": "La conversazione è stata interrotta. La tua sfida è stata salvata; riconnettiti quando sei pronto.",
    "The restart could not be completed. Close this panel, reload progress, and try again.": "Il riavvio non può essere completato. Chiudi questo pannello, ricarica l'avanzamento e riprova.",
    "The results are saved. Equal scores share a place.": "I risultati vengono salvati. I punteggi uguali condividono lo stesso posto.",
    "There is no new result to collect.": "Non ci sono nuovi risultati da raccogliere.",
    "This challenge is complete.": "Questa sfida è completa.",
    "This challenge is no longer current.": "Questa sfida non è più attuale.",
    "This challenge keeps its {language} opponents and progress. Your next challenge or an explicit Restart Game will use {next}.": "Questa sfida mantiene i suoi {language} avversari e i suoi progressi. La tua prossima sfida o un Restart Game esplicito utilizzerà {next}.",
    "This landmark is already complete.": "Questa pietra miliare è già completa.",
    "This resets your regular city and challenge buildings, scores, and coins. Three competitors will be chosen at random again.": "Questo resetta la tua città normale e sfida edifici, punteggi e monete. Tre concorrenti verranno nuovamente scelti a caso.",
    "Three AI city builders. Ten turns. Your next great neighborhood.": "Tre costruttori di città con intelligenza artificiale. Dieci turni. Il tuo prossimo fantastico quartiere.",
    "Three competitors are chosen at random from the six who speak your selected language.": "Tre concorrenti vengono scelti a caso tra i sei che parlano la lingua selezionata.",
    "Tower specialist": "Specialista della torre",
    "Turn {v0} of 10": "Turno {v0} di 10",
    "Unknown challenge action.": "Azione di sfida sconosciuta.",
    "Updating your challenge…": "Aggiornamento della tua sfida...",
    "View challenge results": "Visualizza i risultati della sfida",
    "Visit city": "Visita la città",
    "Visiting {v0}": "Visitando {v0}",
    "Wait for the current response, or press Speak to interrupt.": "Attendi la risposta attuale o premi Parla per interrompere.",
    "YOU": "TU",
    "YOUR MOVE": "LA TUA MOSSA",
    "You": "Tu",
    "You and three competitors each receive 24,000 challenge coins and ten turns. Roll, then upgrade one landmark or save your coins. Every upgrade earns one point.": "Tu e tre concorrenti riceverete ciascuno 24.000 monete sfida e dieci turni. Lancia, poi potenzia un punto di riferimento o salva le tue monete. Ogni upgrade fa guadagnare un punto.",
    "You keep your {rolls} regular rolls and {turns} remaining challenge turns.": "Mantieni i tuoi {rolls} tiri regolari e i {turns} turni di sfida rimanenti.",
    "You need more challenge coins for that upgrade.": "Hai bisogno di più monete sfida per quell'aggiornamento.",
    "You rolled {dice} and earned {coins} challenge coins.": "Hai ottenuto {dice} e guadagnato {coins} monete sfida.",
    "You rolled {v0}. Choose Build or Save below to finish your turn. All three opponents go next.": "Hai ottenuto {v0}. Scegli Costruisci o Salva qui sotto per completare il tuo turno. Tutti e tre gli avversari sono i prossimi.",
    "You saved your coins and continued to the next roll.": "Hai salvato le tue monete e sei proseguito con il tiro successivo.",
    "You saved your coins for a future upgrade.": "Hai salvato le tue monete per un aggiornamento futuro.",
    "You share first place!": "Condividete il primo posto!",
    "You upgraded {landmark} to level {level}.": "Hai aggiornato {landmark} al livello {level}.",
    "Your challenge changed in another window. The latest progress has been loaded.": "La tua sfida è cambiata in un'altra finestra. I progressi più recenti sono stati caricati.",
    "Your challenge city": "La tua città delle sfide",
    "Your challenge record": "Il tuo record di sfide",
    "Your challenge turn": "Il tuo turno di sfida",
    "Your city": "La tua città",
    "Your opponents take their turns after either choice. Roll again to save automatically, let them play, then take your next roll.": "I tuoi avversari si alternano dopo una delle due scelte. Tira di nuovo per salvarlo automaticamente, lasciali giocare e poi fai il tiro successivo.",
    "Your regular city stays separate. Extra rolls from the Shop do not count here. Equal scores share the same place.": "La tua città normale rimane separata. I rotoli extra dello Shop non vengono conteggiati qui. I punteggi uguali condividono lo stesso posto.",
    "Your skyline": "Il tuo skyline",
    "Your skyline wins!": "Il tuo skyline vince!",
    "Your turn · rolling the dice…": "Tocca a te · tirare i dadi...",
    "pts": "punti",
    "rolls remaining": "lanci rimanenti",
    "{coins} challenge coins": "Monete della sfida {coins}",
    "{coins} challenge coins · Last dice {dice}": "{coins} challenge coins · Ultimi dadi {dice}",
    "{coins} coins": "Monete {coins}",
    "{count} challenge rounds left": "Mancano i turni della sfida {count}",
    "{language} challenge · {round} / 10 rounds complete": "Sfida {language} · {round}/10 round completi",
    "{name} rolled {dice}, earned {coins} coins, and saved for a future upgrade.": "{name} ha ottenuto {dice}, ha guadagnato {coins} monete e ha risparmiato per un aggiornamento futuro.",
    "{name} rolled {dice}, earned {coins} coins, and upgraded {landmark} to level {level}.": "{name} ha ottenuto {dice}, ha guadagnato {coins} monete e ha aggiornato {landmark} al livello {level}.",
    "{points} points": "{points} punti",
    "{points} points · {coins} coins": "{points} punti · {coins} monete",
    "{rolls} ROLLS REMAINING": "{rolls} LANCI RIMANENTI",
    "{v0} coins · Level {v1} → {v2}": "{v0} monete · Livello {v1} → {v2}",
    "{v0} points · {v1} coins": "{v0} punti · {v1} monete",
    "{v0} · Level {v1} / 3": "{v0} · Livello {v1}/3",
    "{v0}'s challenge city": "La città delle sfide di {v0}",
    "{v0}’s skyline": "Lo skyline di {v0}",
    "← Back to your city": "← Torna alla tua città",
    "◉ Speak": "◉ Parla",
    "◉ Talk": "◉ Parla",
    "ADMIN ACCESS": "ACCESSO AMMINISTRATORE",
    "Admin · Free": "Amministratore · Gratuito",
    "Choose any roll package. No charge will be made.": "Scegli qualsiasi pacchetto in rotolo. Non verrà effettuato alcun addebito.",
    "{rolls} rolls added at no charge.": "Rotoli {rolls} aggiunti gratuitamente.",
    "Adding…": "Aggiungendo...",
    "{rolls} ROLLS": "{rolls} LANCI"
  },
  "ja-JP": {
    "24,000 coins · 10 turns": "24,000 コイン·10 ターン",
    "3D city unavailable. Your buildings and scores are shown below.": "3D シティはご利用いただけません。あなたの建物とスコアは以下の通りです。",
    "A city worth building.": "建設する価値のある都市。",
    "A friendly race to the skyline.": "スカイラインを駆け巡るフレンドリーなレース。",
    "A request identifier is required.": "リクエスト ID が必要です。",
    "AI PLAYER": "AI プレイヤー",
    "AI competitor": "AI の競合企業",
    "All three opponents finished round {round}.": "3 人の対戦相手全員が {round} ラウンドを終了しました。",
    "An AI player, powered by Experts Alive. Conversations cannot spend coins or change the result.": "エキスパートアライブを搭載したAIプレイヤー。会話でコインを使ったり、結果を変えたりすることはできません。",
    "Ask": "尋ねる",
    "Ask about their strategy": "彼らの戦略について尋ねる",
    "Ask your competitor": "競合他社に聞く",
    "Available for the random draw": "ランダム抽選で利用可能",
    "Balanced builder": "バランスビルダー",
    "Broadway House": "ブロードウェイハウス",
    "Brooklyn Crossing": "ブルックリン・クロッシング",
    "Build": "建設する",
    "Build & finish turn": "ビルド＆フィニッシュターン",
    "Build and finish challenge turn": "チャレンジターンをビルドして終了する",
    "Build once or save": "1 回ビルドするか保存する",
    "Buy more rolls": "ロールをもっと購入",
    "CHALLENGE CITY · NEW YORK": "チャレンジシティ·ニューヨーク",
    "CONNECTING": "接続する",
    "Central Gardens": "セントラルガーデン",
    "Challenge complete": "チャレンジ完了",
    "Challenge controls": "チャレンジコントロール",
    "Challenge standings": "チャレンジ順位",
    "Challenge · Round {v0} of 10": "チャレンジ · 全10ラウンド中{v0}ラウンド目",
    "Challenge · {round} of 10 rounds complete": "チャレンジ·10 ラウンド中 {round} クリア",
    "Choose challenge landmark": "チャレンジランドマークを選択",
    "Choose one of the five landmarks.": "5 つのランドマークから 1 つを選択します。",
    "Choose one of the thirteen supported languages.": "サポートされている 13 の言語から 1 つを選択します。",
    "Choose your landmark · one upgrade earns one point": "ランドマークを選択してください·アップグレード1回につき1ポイント獲得",
    "Close ×": "閉じる ×",
    "Collect result": "結果を収集",
    "Collect saves this result in your challenge record. No coins or paid rewards are awarded.": "Collectはこの結果をチャレンジ記録に保存します。コインや有料報酬は授与されません。",
    "Complete": "完了",
    "Connect online to talk with your competitor.": "オンラインで接続して競合他社と話しましょう。",
    "Connect to Lucky Estates online to save and play a challenge.": "ラッキーエステートにオンラインで接続して、チャレンジを保存してプレイしてください。",
    "DISCONNECTED": "切断されました",
    "Discuss the match, compare strategies, or ask about this city.": "試合について話し合ったり、戦略を比較したり、この都市について尋ねたりしてください。",
    "ERROR": "エラー",
    "Entire city": "都市全体",
    "Everyone starts on the same block.": "全員が同じブロックから始めます。",
    "FINAL STANDINGS": "最終順位",
    "Finish your current challenge first.": "現在のチャレンジを最初に完了してください。",
    "First place: {names}. You earned {points} points.": "1位:{names}.{points} ポイントを獲得しました。",
    "Game restarted. Everyone keeps {count} remaining challenge turns; no rolls were added.": "ゲームが再開されました。全員が残りのチャレンジターン {count} をキープし、ロールは追加されませんでした。",
    "Game restarted. Your remaining rolls were preserved.": "ゲームが再開されました。残りのロールは保存されました。",
    "Harbor Beacon": "ハーバービーコン",
    "IDLE": "アイドル状態",
    "Keep playing": "プレイを続ける",
    "LISTENING": "聞いている",
    "Latest moves": "最新の動き",
    "Level {level} / 3": "レベル {level}/3",
    "Listening — ask your question.": "リスニング—質問をしてください。",
    "Loading challenge…": "チャレンジをロード中...",
    "Loading…": "読み込み中...",
    "Meet your competitors": "対戦相手を紹介",
    "Next goal · Start a city challenge": "次の目標·シティチャレンジを始める",
    "No new rolls are added. Your language, avatar, audio preferences, and previously collected gifts are kept.": "新しいロールは追加されません。言語、アバター、オーディオ設定、以前に収集したギフトは保持されます。",
    "No purchases needed": "購入は不要です",
    "Not enough coins for an upgrade": "アップグレードするにはコインが足りません",
    "Opponent language: {language}": "対戦相手の言語:{language}",
    "Opponents completed their turns": "対戦相手はターンを完了しました",
    "Optional visits and conversations. Your Lucky guide remains available through Explain this.": "オプションの訪問と会話。ラッキーガイドは「説明してください」から引き続きご利用いただけます。",
    "Or Roll to save and continue automatically.": "またはロールして保存し、自動的に続行します。",
    "PLAYERS · CITY CHALLENGE": "プレイヤー·シティチャレンジ",
    "Place {place} · {points} points": "プレイス {place} · {points} ポイント",
    "Play with {language} opponents": "{language} 人の対戦相手とプレイ",
    "Players": "プレイヤー",
    "Players ↗": "プレイヤー ↗",
    "Prefer to keep your coins?": "コインを保管しておきたいですか？",
    "Quick builder": "クイックビルダー",
    "READY": "準備完了",
    "ROUND {round}": "ラウンド {round}",
    "Reconnect": "再接続",
    "Reload progress": "リロードの進行状況",
    "Restart Game": "ゲームを再起動",
    "Restart Game?": "ゲームを再起動?",
    "Restarting…": "再起動中...",
    "Rivals take their turns": "ライバルが順番を決める",
    "Roll again · auto-save coins": "ロール・アゲイン・コインの自動保存",
    "Roll before choosing a building or saving.": "建物を選んだり保存したりする前にロールしてください。",
    "Roll challenge dice": "ロールチャレンジダイス",
    "Roll for coins": "コイン用ロール",
    "Roll here or use the orange Roll button on Play to take your challenge turn.": "ここでロールするか、Playのオレンジ色のRollボタンを使用してチャレンジターンに挑戦してください。",
    "Roll, then choose Build or Save above the Roll button.": "ロールし、ロールボタンの上にある「ビルド」または「保存」を選択します。",
    "SPEAKING": "話す",
    "Save coins": "コインを貯める",
    "Save coins & finish turn →": "コインを貯めてターンを終える →",
    "Save coins and finish challenge turn": "コインを貯めてチャレンジターンを終了する",
    "Save coins for your next upgrade": "次のアップグレードのためにコインを貯めよう",
    "Save your regular game successfully before restarting. Reload if another window changed your game.": "再起動する前に、通常のゲームを正常に保存してください。別のウインドウでゲームが変わった場合は、リロードしてください。",
    "Saving your coins. Opponents take their turns first…": "コインを貯めましょう。対戦相手が最初に順番を取ります...",
    "Saving your move and updating the challenge…": "ムーブを保存してチャレンジを更新中...",
    "Saving…": "保存中...",
    "Select a landmark to look closer": "ランドマークを選択して詳しく見る",
    "Setting up your city…": "都市を設定中...",
    "Skyline Tower": "スカイラインタワー",
    "Start 10-turn challenge": "10ターンのチャレンジを開始する",
    "Start 10-turn challenge →": "10ターンのチャレンジを始める →",
    "Start another challenge": "別のチャレンジを始める",
    "Stop the response and turn on your microphone.": "応答を停止し、マイクをオンにします。",
    "THE TEN-TURN CITY CHALLENGE": "テンターン・シティ・チャレンジ",
    "THINKING": "考えている",
    "Talk with {name}": "{name} と話す",
    "The challenge could not be loaded. Try again.": "チャレンジを読み込めませんでした。もう一度やり直してください。",
    "The conversation was interrupted. Your challenge is saved; reconnect when ready.": "会話は中断されました。チャレンジが保存されました。準備ができたら再接続してください。",
    "The restart could not be completed. Close this panel, reload progress, and try again.": "再起動を完了できませんでした。このパネルを閉じて、進行状況を再度読み込んで、やり直してください。",
    "The results are saved. Equal scores share a place.": "結果が保存されます。スコアが等しい場合は場所を共有します。",
    "There is no new result to collect.": "収集できる新しい結果はありません。",
    "This challenge is complete.": "このチャレンジは完了です。",
    "This challenge is no longer current.": "この課題はもはや時代遅れです。",
    "This challenge keeps its {language} opponents and progress. Your next challenge or an explicit Restart Game will use {next}.": "このチャレンジは {language} の対戦相手を引き留め、進歩を続けます。次のチャレンジまたは明示的なリスタートゲームでは {next} を使います。",
    "This landmark is already complete.": "このランドマークはすでに完成しています。",
    "This resets your regular city and challenge buildings, scores, and coins. Three competitors will be chosen at random again.": "これにより、通常の都市とチャレンジの建物、スコア、コインがリセットされます。再び 3 人の競技者がランダムに選ばれます。",
    "Three AI city builders. Ten turns. Your next great neighborhood.": "3 つの AI シティビルダー。10ターン。あなたの次の素晴らしい近所。",
    "Three competitors are chosen at random from the six who speak your selected language.": "選択した言語を話す6人の中から3人の競技者がランダムに選ばれます。",
    "Tower specialist": "タワースペシャリスト",
    "Turn {v0} of 10": "全10ターン中{v0}ターン目",
    "Unknown challenge action.": "未知のチャレンジアクション。",
    "Updating your challenge…": "チャレンジを更新中...",
    "View challenge results": "チャレンジ結果を見る",
    "Visit city": "訪問都市",
    "Visiting {v0}": "{v0} への訪問",
    "Wait for the current response, or press Speak to interrupt.": "現在の応答を待つか、Speakを押して中断してください。",
    "YOU": "あなた",
    "YOUR MOVE": "あなたの動き",
    "You": "あなた",
    "You and three competitors each receive 24,000 challenge coins and ten turns. Roll, then upgrade one landmark or save your coins. Every upgrade earns one point.": "あなたと3人の競技者はそれぞれ24,000枚のチャレンジコインと10ターンを受け取ります。ランドマークを1つロールしてアップグレードするか、コインを保存してください。アップグレードするたびに1ポイントが貯まります。",
    "You keep your {rolls} regular rolls and {turns} remaining challenge turns.": "{rolls} のレギュラーロールと {turns} の残りのチャレンジターンをキープできます。",
    "You need more challenge coins for that upgrade.": "そのアップグレードにはさらにチャレンジコインが必要です。",
    "You rolled {dice} and earned {coins} challenge coins.": "{dice} を振って {coins} チャレンジコインを獲得した。",
    "You rolled {v0}. Choose Build or Save below to finish your turn. All three opponents go next.": "{v0} を転がしたね。下の [ビルド] または [保存] を選択してターンを終了してください。3 人の対戦相手全員が次に行きます。",
    "You saved your coins and continued to the next roll.": "コインを貯めて、次のロールに進みました。",
    "You saved your coins for a future upgrade.": "今後のアップグレードに備えてコインを貯めました。",
    "You share first place!": "あなたは1位を共有しています！",
    "You upgraded {landmark} to level {level}.": "{landmark} をレベル {level} にアップグレードしました。",
    "Your challenge changed in another window. The latest progress has been loaded.": "チャレンジは別のウィンドウで変更されました。最新の進捗状況が読み込まれました。",
    "Your challenge city": "あなたのチャレンジシティ",
    "Your challenge record": "あなたのチャレンジ記録",
    "Your challenge turn": "あなたのチャレンジターン",
    "Your city": "あなたの街",
    "Your opponents take their turns after either choice. Roll again to save automatically, let them play, then take your next roll.": "どちらかを選択した後、対戦相手が順番を取ります。もう一度ロールすると自動的にセーブされ、相手にプレイさせてから、次のロールを取ります。",
    "Your regular city stays separate. Extra rolls from the Shop do not count here. Equal scores share the same place.": "通常の都市は独立したままです。ショップの余分なロールはここではカウントされません。スコアが等しい場合は同じ場所を共有します。",
    "Your skyline": "あなたのスカイライン",
    "Your skyline wins!": "あなたのスカイラインが勝ちます！",
    "Your turn · rolling the dice…": "あなたの番・サイコロを振って...",
    "pts": "点",
    "rolls remaining": "残り回数",
    "{coins} challenge coins": "{coins} チャレンジコイン",
    "{coins} challenge coins · Last dice {dice}": "{coins} チャレンジコイン·ラストダイス {dice}",
    "{coins} coins": "{coins} コイン",
    "{count} challenge rounds left": "{count} チャレンジラウンド残り",
    "{language} challenge · {round} / 10 rounds complete": "{language} チャレンジ·{round}/10 ラウンド完了",
    "{name} rolled {dice}, earned {coins} coins, and saved for a future upgrade.": "{name} は {dice} を転がして {coins} コインを獲得し、今後のアップグレードに備えて貯金しました。",
    "{name} rolled {dice}, earned {coins} coins, and upgraded {landmark} to level {level}.": "{name} が {dice} を転がして {coins} コインを獲得し、{landmark} をレベル {level} にアップグレードしました。",
    "{points} points": "{points} ポイント",
    "{points} points · {coins} coins": "{points} ポイント·{coins} コイン",
    "{rolls} ROLLS REMAINING": "残り{rolls}回",
    "{v0} coins · Level {v1} → {v2}": "{v0} コイン·レベル {v1} → {v2}",
    "{v0} points · {v1} coins": "{v0} ポイント·{v1} コイン",
    "{v0} · Level {v1} / 3": "{v0} · レベル {v1}/3",
    "{v0}'s challenge city": "{v0} のチャレンジシティ",
    "{v0}’s skyline": "{v0} のスカイライン",
    "← Back to your city": "← あなたの街に戻る",
    "◉ Speak": "◉ スピーク",
    "◉ Talk": "◉ トーク",
    "ADMIN ACCESS": "管理者アクセス",
    "Adding…": "追加中...",
    "Admin · Free": "管理者·無料",
    "{rolls} rolls added at no charge.": "{rolls} ロールは無料で追加されます。",
    "Choose any roll package. No charge will be made.": "任意のロールパッケージを選択してください。料金は発生しません。",
    "{rolls} ROLLS": "残り回数：{rolls}"
  },
  "ko-KR": {
    "24,000 coins · 10 turns": "코인 2만 4천 개 · 턴 10개",
    "3D city unavailable. Your buildings and scores are shown below.": "3D 도시를 사용할 수 없습니다.건물과 점수는 아래에 나와 있습니다.",
    "A city worth building.": "건설할 가치가 있는 도시.",
    "A friendly race to the skyline.": "스카이라인을 향한 친선 레이스.",
    "A request identifier is required.": "요청 식별자가 필요합니다.",
    "AI PLAYER": "인공 지능 플레이어",
    "AI competitor": "AI 경쟁사",
    "All three opponents finished round {round}.": "세 명의 상대 모두 {round} 라운드를 마쳤습니다.",
    "An AI player, powered by Experts Alive. Conversations cannot spend coins or change the result.": "엑스퍼트 얼라이브가 제공하는 AI 플레이어.대화로는 코인을 소비하거나 결과를 바꿀 수 없습니다.",
    "Ask": "물어보세요",
    "Ask about their strategy": "전략에 대해 물어보세요",
    "Ask your competitor": "경쟁자에게 물어보세요",
    "Available for the random draw": "무작위 추첨에 사용 가능",
    "Balanced builder": "밸런스 빌더",
    "Broadway House": "브로드웨이 하우스",
    "Brooklyn Crossing": "브루클린 크로싱",
    "Build": "짓다",
    "Build & finish turn": "턴 빌드 및 피니시",
    "Build and finish challenge turn": "챌린지 턴을 만들고 완료하세요",
    "Build once or save": "한 번 빌드하거나 저장하세요",
    "Buy more rolls": "더 많은 롤 구매하기",
    "CHALLENGE CITY · NEW YORK": "챌린지 시티 · 뉴욕",
    "CONNECTING": "연결",
    "Central Gardens": "센트럴 가든스",
    "Challenge complete": "챌린지 완료",
    "Challenge controls": "챌린지 컨트롤",
    "Challenge standings": "챌린지 순위",
    "Challenge · Round {v0} of 10": "챌린지 · 10라운드 중 {v0}",
    "Challenge · {round} of 10 rounds complete": "챌린지 · 10개 라운드 중 {round} 완료",
    "Choose challenge landmark": "챌린지 랜드마크 선택",
    "Choose one of the five landmarks.": "다섯 가지 랜드마크 중 하나를 선택하세요.",
    "Choose one of the thirteen supported languages.": "지원되는 13개 언어 중 하나를 선택합니다.",
    "Choose your landmark · one upgrade earns one point": "랜드마크 선택 · 한 번의 업그레이드로 1포인트 적립",
    "Close ×": "닫기 ×",
    "Collect result": "결과 수집",
    "Collect saves this result in your challenge record. No coins or paid rewards are awarded.": "Collect는 이 결과를 챌린지 기록에 저장합니다.코인이나 유료 보상은 지급되지 않습니다.",
    "Complete": "완료",
    "Connect online to talk with your competitor.": "온라인으로 연결하여 경쟁자와 대화하세요.",
    "Connect to Lucky Estates online to save and play a challenge.": "온라인으로 Lucky Estates에 연결하여 저장하고 챌린지를 플레이하세요.",
    "DISCONNECTED": "연결이 끊어졌습니다",
    "Discuss the match, compare strategies, or ask about this city.": "경기에 대해 토론하고 전략을 비교하거나 이 도시에 대해 물어보세요.",
    "ERROR": "오류",
    "Entire city": "도시 전체",
    "Everyone starts on the same block.": "모두가 같은 블록에서 시작합니다.",
    "FINAL STANDINGS": "최종 순위",
    "Finish your current challenge first.": "현재 챌린지를 먼저 완료하세요.",
    "First place: {names}. You earned {points} points.": "1위: {names}.{points} 포인트를 획득했습니다.",
    "Game restarted. Everyone keeps {count} remaining challenge turns; no rolls were added.": "게임이 다시 시작되었습니다.모두가 {count} 남은 챌린지 턴을 기록합니다. 롤은 추가되지 않았습니다.",
    "Game restarted. Your remaining rolls were preserved.": "게임이 다시 시작되었습니다.남은 롤은 보존되었습니다.",
    "Harbor Beacon": "하버 비컨",
    "IDLE": "게으른",
    "Keep playing": "계속 플레이하세요",
    "LISTENING": "청취",
    "Latest moves": "최신 동작",
    "Level {level} / 3": "레벨 {level}/3",
    "Listening — ask your question.": "듣기 — 질문을 하세요.",
    "Loading challenge…": "로딩 문제...",
    "Loading…": "로드 중...",
    "Meet your competitors": "경쟁사 만나기",
    "Next goal · Start a city challenge": "다음 목표 · 도시 챌린지 시작",
    "No new rolls are added. Your language, avatar, audio preferences, and previously collected gifts are kept.": "새 롤은 추가되지 않습니다.언어, 아바타, 오디오 기본 설정 및 이전에 수집한 선물은 그대로 유지됩니다.",
    "No purchases needed": "구매 불필요",
    "Not enough coins for an upgrade": "업그레이드에 필요한 코인이 부족합니다",
    "Opponent language: {language}": "상대 언어: {language}",
    "Opponents completed their turns": "상대방이 턴을 완료했습니다",
    "Optional visits and conversations. Your Lucky guide remains available through Explain this.": "선택적 방문 및 대화.'Explain-this (설명) '를 통해 행운의 가이드를 계속 이용할 수 있습니다.",
    "Or Roll to save and continue automatically.": "또는 Roll을 눌러 자동으로 저장하고 계속할 수 있습니다.",
    "PLAYERS · CITY CHALLENGE": "플레이어 · 시티 챌린지",
    "Place {place} · {points} points": "장소 {place} · {points} 포인트",
    "Play with {language} opponents": "{language} 상대와 함께 플레이하세요",
    "Players": "플레이어",
    "Players ↗": "플레이어 ↗",
    "Prefer to keep your coins?": "코인을 보관하고 싶으신가요?",
    "Quick builder": "퀵 빌더",
    "READY": "준비된",
    "ROUND {round}": "라운드 {round}",
    "Reconnect": "재연결",
    "Reload progress": "진행률 새로 고침",
    "Restart Game": "게임 재시작",
    "Restart Game?": "게임을 다시 시작할까요?",
    "Restarting…": "재시작 중...",
    "Rivals take their turns": "차례대로 돌아가는 라이벌",
    "Roll again · auto-save coins": "롤 어게인 · 코인 자동 저장",
    "Roll before choosing a building or saving.": "건물을 선택하거나 저축하기 전에 굴리십시오.",
    "Roll challenge dice": "롤 챌린지 주사위",
    "Roll for coins": "롤 포 코인",
    "Roll here or use the orange Roll button on Play to take your challenge turn.": "여기에서 굴리거나 Play의 주황색 Roll 버튼을 사용하여 챌린지 턴을 진행하세요.",
    "Roll, then choose Build or Save above the Roll button.": "롤을 선택한 다음 롤 버튼 위에서 빌드 또는 저장을 선택합니다.",
    "SPEAKING": "말하기",
    "Save coins": "코인 저장",
    "Save coins & finish turn →": "코인 저장 및 턴 완료 →",
    "Save coins and finish challenge turn": "코인을 절약하고 챌린지 턴을 완료하세요",
    "Save coins for your next upgrade": "다음 업그레이드를 위해 코인을 절약하세요",
    "Save your regular game successfully before restarting. Reload if another window changed your game.": "다시 시작하기 전에 일반 게임을 성공적으로 저장하세요.다른 창에서 게임이 변경되었다면 다시 로드하세요.",
    "Saving your coins. Opponents take their turns first…": "코인 저장하기.상대방이 먼저 턴을 시작합니다...",
    "Saving your move and updating the challenge…": "움직임을 저장하고 챌린지를 업데이트하는 중...",
    "Saving…": "저장 중...",
    "Select a landmark to look closer": "랜드마크를 선택하면 더 자세히 볼 수 있습니다.",
    "Setting up your city…": "도시 설정 중...",
    "Skyline Tower": "스카이라인 타워",
    "Start 10-turn challenge": "10턴 챌린지 시작",
    "Start 10-turn challenge →": "10턴 챌린지 시작 →",
    "Start another challenge": "또 다른 도전을 시작하세요",
    "Stop the response and turn on your microphone.": "응답을 중지하고 마이크를 켜십시오.",
    "THE TEN-TURN CITY CHALLENGE": "10턴 시티 챌린지",
    "THINKING": "생각",
    "Talk with {name}": "{name} 님과 대화하세요",
    "The challenge could not be loaded. Try again.": "챌린지를 로드할 수 없습니다.다시 시도하세요.",
    "The conversation was interrupted. Your challenge is saved; reconnect when ready.": "대화가 중단되었습니다.챌린지가 저장되었습니다. 준비가 되면 다시 연결하세요.",
    "The restart could not be completed. Close this panel, reload progress, and try again.": "재시작을 완료할 수 없습니다.이 패널을 닫고 진행 상황을 다시 로드한 다음 다시 시도하세요.",
    "The results are saved. Equal scores share a place.": "결과가 저장됩니다.동일한 점수는 한 자리를 공유합니다.",
    "There is no new result to collect.": "수집할 새 결과가 없습니다.",
    "This challenge is complete.": "이 챌린지는 완료되었습니다.",
    "This challenge is no longer current.": "이 과제는 더 이상 유효하지 않습니다.",
    "This challenge keeps its {language} opponents and progress. Your next challenge or an explicit Restart Game will use {next}.": "이 챌린지는 {language} 상대와 진행 상황을 유지합니다.다음 챌린지나 명시적으로 게임을 다시 시작할 때는 {next} 를 사용합니다.",
    "This landmark is already complete.": "이 랜드마크는 이미 완성되었습니다.",
    "This resets your regular city and challenge buildings, scores, and coins. Three competitors will be chosen at random again.": "그러면 일반 도시 및 챌린지 건물, 점수, 동전이 초기화됩니다.세 명의 경쟁자가 다시 무작위로 선택됩니다.",
    "Three AI city builders. Ten turns. Your next great neighborhood.": "세 명의 AI 시티 빌더.열 턴.다음 멋진 동네.",
    "Three competitors are chosen at random from the six who speak your selected language.": "선택한 언어를 구사하는 6명의 선수 중 3명의 선수가 무작위로 선택됩니다.",
    "Tower specialist": "타워 스페셜리스트",
    "Turn {v0} of 10": "턴 {v0} (10개 중)",
    "Unknown challenge action.": "알 수 없는 챌린지 액션입니다.",
    "Updating your challenge…": "챌린지 업데이트 중...",
    "View challenge results": "챌린지 결과 보기",
    "Visit city": "도시 방문",
    "Visiting {v0}": "방문 {v0}",
    "Wait for the current response, or press Speak to interrupt.": "현재 응답을 기다리거나 Speak 키를 눌러 중단합니다.",
    "YOU": "당신",
    "YOUR MOVE": "너의 움직임",
    "You": "당신",
    "You and three competitors each receive 24,000 challenge coins and ten turns. Roll, then upgrade one landmark or save your coins. Every upgrade earns one point.": "당신과 세 명의 경쟁자는 각각 24,000 챌린지 코인과 10 턴을 받습니다.굴려서 랜드마크 하나를 업그레이드하거나 코인을 저장하세요.업그레이드할 때마다 1포인트가 적립됩니다.",
    "You keep your {rolls} regular rolls and {turns} remaining challenge turns.": "{rolls} 일반 롤과 {turns} 남은 챌린지 턴을 유지합니다.",
    "You need more challenge coins for that upgrade.": "업그레이드하려면 더 많은 챌린지 코인이 필요합니다.",
    "You rolled {dice} and earned {coins} challenge coins.": "{dice} 게임을 플레이하고 {coins} 챌린지 코인을 획득했습니다.",
    "You rolled {v0}. Choose Build or Save below to finish your turn. All three opponents go next.": "{v0} 롤업했잖아아래에서 건설 또는 저장을 선택하여 턴을 완료하세요.세 명의 상대가 모두 다음으로 갑니다.",
    "You saved your coins and continued to the next roll.": "코인을 모으고 다음 롤로 넘어갔습니다.",
    "You saved your coins for a future upgrade.": "향후 업그레이드를 위해 코인을 저장했습니다.",
    "You share first place!": "당신은 첫 번째 자리를 공유합니다!",
    "You upgraded {landmark} to level {level}.": "{landmark} 레벨을 {level} 레벨로 업그레이드했습니다.",
    "Your challenge changed in another window. The latest progress has been loaded.": "다른 창에서 챌린지가 변경되었습니다.최신 진행 상황이 로드되었습니다.",
    "Your challenge city": "나만의 챌린지 시티",
    "Your challenge record": "내 챌린지 기록",
    "Your challenge turn": "당신의 챌린지 턴",
    "Your city": "내 도시",
    "Your opponents take their turns after either choice. Roll again to save automatically, let them play, then take your next roll.": "상대는 어느 쪽이든 골라 차례를 맞춥니다.다시 굴려서 자동으로 저장하고, 플레이하게 한 다음, 다음 롤을 가져가세요.",
    "Your regular city stays separate. Extra rolls from the Shop do not count here. Equal scores share the same place.": "일반 도시는 별도로 유지됩니다.상점에서 구매한 추가 롤은 여기에 포함되지 않습니다.동일한 점수라도 같은 자리를 공유합니다.",
    "Your skyline": "나만의 스카이라인",
    "Your skyline wins!": "스카이라인이 이깁니다!",
    "Your turn · rolling the dice…": "네 차례 · 주사위 굴리기...",
    "pts": "pt",
    "rolls remaining": "남은 주사위 횟수",
    "{coins} challenge coins": "{coins} 챌린지 코인",
    "{coins} challenge coins · Last dice {dice}": "{coins} 챌린지 코인 · 라스트 다이스 {dice}",
    "{coins} coins": "{coins} 코인",
    "{count} challenge rounds left": "{count} 챌린지 라운드 남음",
    "{language} challenge · {round} / 10 rounds complete": "{language} 챌린지 · {round} /10라운드 완료",
    "{name} rolled {dice}, earned {coins} coins, and saved for a future upgrade.": "{name} 는 {dice} 돌리고 {coins} 코인을 획득하고 향후 업그레이드를 위해 저장했습니다.",
    "{name} rolled {dice}, earned {coins} coins, and upgraded {landmark} to level {level}.": "{name} {dice} 굴리고 {coins} 코인을 획득하고 {landmark} 레벨을 {level} 레벨로 업그레이드했습니다.",
    "{points} points": "{points} 포인트",
    "{points} points · {coins} coins": "{points} 포인트 · {coins} 코인",
    "{rolls} ROLLS REMAINING": "남은 주사위 횟수: {rolls}",
    "{v0} coins · Level {v1} → {v2}": "{v0} 코인 · 레벨 {v1} → {v2}",
    "{v0} points · {v1} coins": "{v0} 포인트 · {v1} 코인",
    "{v0} · Level {v1} / 3": "{v0} · 레벨 {v1}/3",
    "{v0}'s challenge city": "{v0} 챌린지 시티",
    "{v0}’s skyline": "{v0} 스카이라인",
    "← Back to your city": "← 내 도시로 돌아가기",
    "◉ Speak": "◉ 말하기",
    "◉ Talk": "◉ 토크",
    "Adding…": "추가 중...",
    "ADMIN ACCESS": "관리자 액세스",
    "Admin · Free": "관리자 · 무료",
    "{rolls} rolls added at no charge.": "{rolls} 롤이 무료로 추가됩니다.",
    "Choose any roll package. No charge will be made.": "원하는 롤 패키지를 선택하세요.요금은 부과되지 않습니다.",
    "{rolls} ROLLS": "주사위 횟수: {rolls}"
  },
  "pt-BR": {
    "24,000 coins · 10 turns": "24.000 moedas · 10 turnos",
    "3D city unavailable. Your buildings and scores are shown below.": "Cidade 3D indisponível. Seus edifícios e pontuações são mostrados abaixo.",
    "A city worth building.": "Uma cidade que vale a pena construir.",
    "A friendly race to the skyline.": "Uma corrida amigável até o horizonte.",
    "A request identifier is required.": "É necessário um identificador de solicitação.",
    "AI PLAYER": "JOGADOR DE INTELIGÊNCIA ARTIFICIAL",
    "AI competitor": "Concorrente de IA",
    "All three opponents finished round {round}.": "Todos os três adversários terminaram a rodada {round}.",
    "An AI player, powered by Experts Alive. Conversations cannot spend coins or change the result.": "Um player de IA, desenvolvido por Experts Alive. As conversas não podem gastar moedas nem alterar o resultado.",
    "Ask": "Pergunte",
    "Ask about their strategy": "Pergunte sobre a estratégia deles",
    "Ask your competitor": "Pergunte ao seu concorrente",
    "Available for the random draw": "Disponível para o sorteio aleatório",
    "Balanced builder": "Construtor equilibrado",
    "Broadway House": "Casa da Broadway",
    "Brooklyn Crossing": "Cruzamento do Brooklyn",
    "Build": "Construir",
    "Build & finish turn": "Construa e termine o turno",
    "Build and finish challenge turn": "Construa e termine o turno do desafio",
    "Build once or save": "Crie uma vez ou salve",
    "Buy more rolls": "Compre mais rolos",
    "CHALLENGE CITY · NEW YORK": "CHALLENGE CITY · NOVA IORQUINA",
    "CONNECTING": "CONECTANDO",
    "Central Gardens": "Jardins Centrais",
    "Challenge complete": "Desafio concluído",
    "Challenge controls": "Controles de desafio",
    "Challenge standings": "Classificação do Desafio",
    "Challenge · Round {v0} of 10": "Desafio · Rodada {v0} de 10",
    "Challenge · {round} of 10 rounds complete": "Desafio · {round} de 10 rodadas concluídas",
    "Choose challenge landmark": "Escolha o marco do desafio",
    "Choose one of the five landmarks.": "Escolha um dos cinco pontos de referência.",
    "Choose one of the thirteen supported languages.": "Escolha um dos treze idiomas suportados.",
    "Choose your landmark · one upgrade earns one point": "Escolha seu ponto de referência · um upgrade ganha um ponto",
    "Close ×": "Fechar ×",
    "Collect result": "Colete o resultado",
    "Collect saves this result in your challenge record. No coins or paid rewards are awarded.": "Collect salva esse resultado em seu recorde de desafios. Nenhuma moeda ou recompensa paga é concedida.",
    "Complete": "Completo",
    "Connect online to talk with your competitor.": "Conecte-se on-line para conversar com seu concorrente.",
    "Connect to Lucky Estates online to save and play a challenge.": "Conecte-se ao Lucky Estates online para salvar e jogar um desafio.",
    "DISCONNECTED": "DESCONECTADO",
    "Discuss the match, compare strategies, or ask about this city.": "Discuta a partida, compare estratégias ou pergunte sobre essa cidade.",
    "ERROR": "ERRO",
    "Entire city": "Cidade inteira",
    "Everyone starts on the same block.": "Todos começam no mesmo quarteirão.",
    "FINAL STANDINGS": "CLASSIFICAÇÃO FINAL",
    "Finish your current challenge first.": "Termine seu desafio atual primeiro.",
    "First place: {names}. You earned {points} points.": "Primeiro lugar: {names}. Você ganhou {points} pontos.",
    "Game restarted. Everyone keeps {count} remaining challenge turns; no rolls were added.": "O jogo foi reiniciado. Todos ficam com {count} dos turnos de desafio restantes; nenhuma jogada foi adicionada.",
    "Game restarted. Your remaining rolls were preserved.": "O jogo foi reiniciado. Seus rolos restantes foram preservados.",
    "Harbor Beacon": "Farol do porto",
    "IDLE": "OCIOSO",
    "Keep playing": "Continue jogando",
    "LISTENING": "OUVINDO",
    "Latest moves": "Últimos movimentos",
    "Level {level} / 3": "Nível {level}/3",
    "Listening — ask your question.": "Ouvindo — faça sua pergunta.",
    "Loading challenge…": "Carregando desafio...",
    "Loading…": "Carregando...",
    "Meet your competitors": "Conheça seus concorrentes",
    "Next goal · Start a city challenge": "Próximo objetivo · Comece um desafio na cidade",
    "No new rolls are added. Your language, avatar, audio preferences, and previously collected gifts are kept.": "Nenhum novo rolo é adicionado. Seu idioma, avatar, preferências de áudio e presentes coletados anteriormente são mantidos.",
    "No purchases needed": "Nenhuma compra é necessária",
    "Not enough coins for an upgrade": "Moedas insuficientes para um upgrade",
    "Opponent language: {language}": "Idioma do oponente: {language}",
    "Opponents completed their turns": "Os oponentes completaram seus turnos",
    "Optional visits and conversations. Your Lucky guide remains available through Explain this.": "Visitas e conversas opcionais. Seu guia Lucky permanece disponível em Explain this.",
    "Or Roll to save and continue automatically.": "Ou role para salvar e continuar automaticamente.",
    "PLAYERS · CITY CHALLENGE": "JOGADORES · DESAFIO DA CIDADE",
    "Place {place} · {points} points": "Coloque {place} · {points} pontos",
    "Play with {language} opponents": "Jogue com oponentes do {language}",
    "Players": "Jogadores",
    "Players ↗": "Jogadores ↗",
    "Prefer to keep your coins?": "Prefere guardar suas moedas?",
    "Quick builder": "Construtor rápido",
    "READY": "PRONTO",
    "ROUND {round}": "RODADA {round}",
    "Reconnect": "Reconectar",
    "Reload progress": "Progresso da recarga",
    "Restart Game": "Reiniciar o jogo",
    "Restart Game?": "Reiniciar o jogo?",
    "Restarting…": "Reiniciando...",
    "Rivals take their turns": "Os rivais se revezam",
    "Roll again · auto-save coins": "Role novamente · salve moedas automaticamente",
    "Roll before choosing a building or saving.": "Role antes de escolher um prédio ou salvar.",
    "Roll challenge dice": "Lance os dados do desafio",
    "Roll for coins": "Rolo para moedas",
    "Roll here or use the orange Roll button on Play to take your challenge turn.": "Role aqui ou use o botão laranja Rolar em Jogar para completar seu turno de desafio.",
    "Roll, then choose Build or Save above the Roll button.": "Role e escolha Construir ou Salvar acima do botão Rolar.",
    "SPEAKING": "FALANDO",
    "Save coins": "Economize moedas",
    "Save coins & finish turn →": "Salve moedas e termine o turno →",
    "Save coins and finish challenge turn": "Economize moedas e termine o turno do desafio",
    "Save coins for your next upgrade": "Economize moedas para sua próxima atualização",
    "Save your regular game successfully before restarting. Reload if another window changed your game.": "Salve seu jogo normal com sucesso antes de reiniciar. Recarregue se outra janela mudar seu jogo.",
    "Saving your coins. Opponents take their turns first…": "Salvando suas moedas. Os oponentes se revezam primeiro...",
    "Saving your move and updating the challenge…": "Salvando sua jogada e atualizando o desafio...",
    "Saving…": "Salvando...",
    "Select a landmark to look closer": "Selecione um ponto de referência para olhar mais de perto",
    "Setting up your city…": "Configurando sua cidade...",
    "Skyline Tower": "Torre Skyline",
    "Start 10-turn challenge": "Comece o desafio de 10 turnos",
    "Start 10-turn challenge →": "Comece o desafio de 10 turnos →",
    "Start another challenge": "Comece outro desafio",
    "Stop the response and turn on your microphone.": "Pare a resposta e ligue o microfone.",
    "THE TEN-TURN CITY CHALLENGE": "O DESAFIO DA CIDADE DE DEZ VOLTAS",
    "THINKING": "PENSANDO",
    "Talk with {name}": "Fale com {name}",
    "The challenge could not be loaded. Try again.": "O desafio não pôde ser carregado. Tente novamente.",
    "The conversation was interrupted. Your challenge is saved; reconnect when ready.": "A conversa foi interrompida. Seu desafio está salvo; reconecte-se quando estiver pronto.",
    "The restart could not be completed. Close this panel, reload progress, and try again.": "A reinicialização não pôde ser concluída. Feche esse painel, recarregue o progresso e tente novamente.",
    "The results are saved. Equal scores share a place.": "Os resultados são salvos. Pontuações iguais dividem um lugar.",
    "There is no new result to collect.": "Não há nenhum resultado novo a ser coletado.",
    "This challenge is complete.": "Esse desafio está completo.",
    "This challenge is no longer current.": "Esse desafio não é mais atual.",
    "This challenge keeps its {language} opponents and progress. Your next challenge or an explicit Restart Game will use {next}.": "Esse desafio mantém seus oponentes {language} e progride. Seu próximo desafio ou um jogo de reinício explícito usará {next}.",
    "This landmark is already complete.": "Esse marco já está completo.",
    "This resets your regular city and challenge buildings, scores, and coins. Three competitors will be chosen at random again.": "Isso redefine sua cidade normal e desafia edifícios, pontuações e moedas. Três competidores serão escolhidos aleatoriamente novamente.",
    "Three AI city builders. Ten turns. Your next great neighborhood.": "Três construtores de cidades com IA. Dez turnos. Seu próximo ótimo bairro.",
    "Three competitors are chosen at random from the six who speak your selected language.": "Três competidores são escolhidos aleatoriamente entre os seis que falam o idioma selecionado.",
    "Tower specialist": "Especialista em torres",
    "Turn {v0} of 10": "Turno {v0} de 10",
    "Unknown challenge action.": "Ação de desafio desconhecida.",
    "Updating your challenge…": "Atualizando seu desafio...",
    "View challenge results": "Veja os resultados do desafio",
    "Visit city": "Visite a cidade",
    "Visiting {v0}": "Visitando {v0}",
    "Wait for the current response, or press Speak to interrupt.": "Aguarde a resposta atual ou pressione Falar para interromper.",
    "YOU": "VOCÊ",
    "YOUR MOVE": "SUA JOGADA",
    "You": "Você",
    "You and three competitors each receive 24,000 challenge coins and ten turns. Roll, then upgrade one landmark or save your coins. Every upgrade earns one point.": "Você e três competidores recebem, cada um, 24.000 moedas de desafio e dez rodadas. Role e, em seguida, atualize um ponto de referência ou salve suas moedas. Cada upgrade rende um ponto.",
    "You keep your {rolls} regular rolls and {turns} remaining challenge turns.": "Você mantém suas jogadas regulares {rolls} e {turns} turnos de desafio restantes.",
    "You need more challenge coins for that upgrade.": "Você precisa de mais moedas de desafio para essa atualização.",
    "You rolled {dice} and earned {coins} challenge coins.": "Você ganhou {dice} e ganhou {coins} moedas de desafio.",
    "You rolled {v0}. Choose Build or Save below to finish your turn. All three opponents go next.": "Você venceu {v0}. Escolha Construir ou Salvar abaixo para terminar seu turno. Todos os três adversários são os próximos.",
    "You saved your coins and continued to the next roll.": "Você salvou suas moedas e continuou para a próxima jogada.",
    "You saved your coins for a future upgrade.": "Você guardou suas moedas para uma atualização futura.",
    "You share first place!": "Você compartilha o primeiro lugar!",
    "You upgraded {landmark} to level {level}.": "Você atualizou {landmark} para o nível {level}.",
    "Your challenge changed in another window. The latest progress has been loaded.": "Seu desafio mudou em outra janela. O progresso mais recente foi carregado.",
    "Your challenge city": "Sua cidade desafiadora",
    "Your challenge record": "Seu recorde de desafios",
    "Your challenge turn": "Sua virada de desafio",
    "Your city": "Sua cidade",
    "Your opponents take their turns after either choice. Roll again to save automatically, let them play, then take your next roll.": "Seus oponentes se revezam após qualquer uma das escolhas. Role novamente para salvar automaticamente, deixe-os jogar e faça a próxima jogada.",
    "Your regular city stays separate. Extra rolls from the Shop do not count here. Equal scores share the same place.": "Sua cidade normal permanece separada. Os rolos extras da loja não contam aqui. Pontuações iguais dividem o mesmo lugar.",
    "Your skyline": "Seu horizonte",
    "Your skyline wins!": "Seu horizonte vence!",
    "Your turn · rolling the dice…": "Sua vez · jogar os dados...",
    "pts": "pts",
    "rolls remaining": "jogadas restantes",
    "{coins} challenge coins": "Moedas de desafio {coins}",
    "{coins} challenge coins · Last dice {dice}": "Moedas de desafio {coins} · Últimos dados {dice}",
    "{coins} coins": "Moedas {coins}",
    "{count} challenge rounds left": "{count} rodadas restantes do desafio",
    "{language} challenge · {round} / 10 rounds complete": "Desafio {language} · {round}/10 rodadas concluídas",
    "{name} rolled {dice}, earned {coins} coins, and saved for a future upgrade.": "{name} ganhou {dice}, ganhou {coins} moedas e salvou para uma atualização futura.",
    "{name} rolled {dice}, earned {coins} coins, and upgraded {landmark} to level {level}.": "{name} ganhou {dice}, ganhou {coins} moedas e melhorou {landmark} para o nível {level}.",
    "{points} points": "{points} pontos",
    "{points} points · {coins} coins": "{points} pontos · {coins} moedas",
    "{rolls} ROLLS REMAINING": "{rolls} JOGADAS RESTANTES",
    "{v0} coins · Level {v1} → {v2}": "{v0} moedas · Nível {v1} → {v2}",
    "{v0} points · {v1} coins": "{v0} pontos · {v1} moedas",
    "{v0} · Level {v1} / 3": "{v0} · Nível {v1}/3",
    "{v0}'s challenge city": "A cidade desafiadora de {v0}",
    "{v0}’s skyline": "Horizonte de {v0}",
    "← Back to your city": "← De volta à sua cidade",
    "◉ Speak": "◉ Fale",
    "◉ Talk": "◉ Converse",
    "ADMIN ACCESS": "ACESSO ADMINISTRATIVO",
    "Adding…": "Adicionando...",
    "Admin · Free": "Admin · Gratuito",
    "Choose any roll package. No charge will be made.": "Escolha qualquer pacote em rolo. Nenhuma cobrança será feita.",
    "{rolls} rolls added at no charge.": "{rolls} rolos adicionados sem nenhum custo.",
    "{rolls} ROLLS": "{rolls} JOGADAS"
  },
  "ru-RU": {
    "24,000 coins · 10 turns": "24 000 монет · 10 ходов",
    "3D city unavailable. Your buildings and scores are shown below.": "3D-город недоступен. Ваши здания и баллы показаны ниже.",
    "A city worth building.": "Город, который стоит построить.",
    "A friendly race to the skyline.": "Дружественная гонка к горизонту.",
    "A request identifier is required.": "Требуется идентификатор запроса.",
    "AI PLAYER": "AI-ПЛЕЕР",
    "AI competitor": "Конкурент ИИ",
    "All three opponents finished round {round}.": "Все три соперника завершили раунд {round}.",
    "An AI player, powered by Experts Alive. Conversations cannot spend coins or change the result.": "Игрок с искусственным интеллектом на базе Experts Alive. Беседы не могут потратить монеты или изменить результат.",
    "Ask": "Спросите",
    "Ask about their strategy": "Спросите об их стратегии",
    "Ask your competitor": "Спросите своего конкурента",
    "Available for the random draw": "Доступно для случайного розыгрыша",
    "Balanced builder": "Сбалансированный строитель",
    "Broadway House": "Бродвейский дом",
    "Brooklyn Crossing": "Бруклинский переезд",
    "Build": "Построить",
    "Build & finish turn": "Постройте и завершите ход",
    "Build and finish challenge turn": "Постройте и завершите испытательный ход",
    "Build once or save": "Создайте один раз или сохраните",
    "Buy more rolls": "Купите больше роллов",
    "CHALLENGE CITY · NEW YORK": "ЧЕЛЛЕНДЖ-СИТИ · НЬЮ-ЙОРК",
    "CONNECTING": "СОЕДИНИТЕЛЬНЫЙ",
    "Central Gardens": "Центральные сады",
    "Challenge complete": "Задание выполнено",
    "Challenge controls": "Управление испытаниями",
    "Challenge standings": "Турнирная таблица",
    "Challenge · Round {v0} of 10": "Вызов · Раунд {v0} из 10",
    "Challenge · {round} of 10 rounds complete": "Вызов · {round} из 10 завершенных раундов",
    "Choose challenge landmark": "Выберите ориентир конкурса",
    "Choose one of the five landmarks.": "Выберите одну из пяти достопримечательностей.",
    "Choose one of the thirteen supported languages.": "Выберите один из тринадцати поддерживаемых языков.",
    "Choose your landmark · one upgrade earns one point": "Выберите свою достопримечательность · одно улучшение приносит одно очко",
    "Close ×": "Закрыть ×",
    "Collect result": "Соберите результат",
    "Collect saves this result in your challenge record. No coins or paid rewards are awarded.": "Collect сохраняет этот результат в вашей записи испытаний. Монеты или платные награды не начисляются.",
    "Complete": "Завершить",
    "Connect online to talk with your competitor.": "Подключитесь к Интернету, чтобы поговорить со своим конкурентом.",
    "Connect to Lucky Estates online to save and play a challenge.": "Подключайтесь к Lucky Estates онлайн, чтобы сэкономить и принять участие в конкурсе.",
    "DISCONNECTED": "ОТКЛЮЧЕН",
    "Discuss the match, compare strategies, or ask about this city.": "Обсудите матч, сравните стратегии или спросите об этом городе.",
    "ERROR": "ОШИБКА",
    "Entire city": "Весь город",
    "Everyone starts on the same block.": "Все начинают с одного и того же блока.",
    "FINAL STANDINGS": "ОКОНЧАТЕЛЬНЫЙ ЗАЧЕТ",
    "Finish your current challenge first.": "Сначала выполните текущее задание.",
    "First place: {names}. You earned {points} points.": "Первое место: {names}. Вы заработали {points} балла.",
    "Game restarted. Everyone keeps {count} remaining challenge turns; no rolls were added.": "Игра перезапущена. Все игроки сохраняют {count} оставшихся ходов за испытаниями; ни один бросок добавлен не был.",
    "Game restarted. Your remaining rolls were preserved.": "Игра перезапущена. Оставшиеся рулоны сохранились.",
    "Harbor Beacon": "Портовый маяк",
    "IDLE": "ВХОЛОСТУЮ",
    "Keep playing": "Продолжай играть",
    "LISTENING": "ПРОСЛУШИВАНИЕ",
    "Latest moves": "Последние шаги",
    "Level {level} / 3": "Уровень {level}/3",
    "Listening — ask your question.": "Слушайте — задайте свой вопрос.",
    "Loading challenge…": "Проблема с загрузкой...",
    "Loading…": "Загрузка...",
    "Meet your competitors": "Познакомьтесь со своими конкурентами",
    "Next goal · Start a city challenge": "Следующая цель · Начните соревнование по городу",
    "No new rolls are added. Your language, avatar, audio preferences, and previously collected gifts are kept.": "Новые рулоны не добавляются. Ваш язык, аватар, настройки звука и ранее собранные подарки сохраняются.",
    "No purchases needed": "Покупки не нужны",
    "Not enough coins for an upgrade": "Недостаточно монет для апгрейда",
    "Opponent language: {language}": "Язык соперника: {language}",
    "Opponents completed their turns": "Соперники завершили свои ходы",
    "Optional visits and conversations. Your Lucky guide remains available through Explain this.": "Дополнительные визиты и беседы. Ваш путеводитель «Счастливый» по-прежнему доступен на сайте Explain this.",
    "Or Roll to save and continue automatically.": "Или переверните, чтобы сохранить и продолжить автоматически.",
    "PLAYERS · CITY CHALLENGE": "ИГРОКИ · ГОРОДСКОЙ ВЫЗОВ",
    "Place {place} · {points} points": "Место {place} · {points} баллов",
    "Play with {language} opponents": "Играйте с соперниками {language}",
    "Players": "Игроки",
    "Players ↗": "Игроки ↗",
    "Prefer to keep your coins?": "Предпочитаете хранить монеты?",
    "Quick builder": "Быстрый конструктор",
    "READY": "ГОТОВЫЙ",
    "ROUND {round}": "РАУНД {round}",
    "Reconnect": "Переподключитесь",
    "Reload progress": "Прогресс перезагрузки",
    "Restart Game": "Перезапустить игру",
    "Restart Game?": "Перезапустить игру?",
    "Restarting…": "Перезапуск...",
    "Rivals take their turns": "Соперники идут по очереди",
    "Roll again · auto-save coins": "Снова катитесь · автоматическое сохранение монет",
    "Roll before choosing a building or saving.": "Прокатитесь, прежде чем выбрать здание или сэкономить.",
    "Roll challenge dice": "Бросайте вызов кубикам",
    "Roll for coins": "Рулон для монет",
    "Roll here or use the orange Roll button on Play to take your challenge turn.": "Играйте здесь или используйте оранжевую кнопку Roll в игре, чтобы принять участие в испытании.",
    "Roll, then choose Build or Save above the Roll button.": "Прокрутите, затем нажмите кнопку «Собрать» или «Сохранить» над кнопкой «Запустить».",
    "SPEAKING": "ГОВОРЯЩИЙ",
    "Save coins": "Экономьте монеты",
    "Save coins & finish turn →": "Сэкономьте монеты и завершите ход →",
    "Save coins and finish challenge turn": "Сэкономьте монеты и завершите ход испытания",
    "Save coins for your next upgrade": "Сэкономьте монеты для следующего обновления",
    "Save your regular game successfully before restarting. Reload if another window changed your game.": "Успешно сохраните обычную игру перед перезапуском. Перезагрузите игру, если другое окно изменило вашу игру.",
    "Saving your coins. Opponents take their turns first…": "Сохранение монет. Противники первыми выберут свою очередь...",
    "Saving your move and updating the challenge…": "Сохраните свой ход и обновите задание...",
    "Saving…": "Сохранение...",
    "Select a landmark to look closer": "Выберите достопримечательность, чтобы посмотреть поближе",
    "Setting up your city…": "Настройка города...",
    "Skyline Tower": "Башня «Скайлайн»",
    "Start 10-turn challenge": "Начните испытание из 10 оборотов",
    "Start 10-turn challenge →": "Начните соревнование из 10 ходов →",
    "Start another challenge": "Приступите к новому испытанию",
    "Stop the response and turn on your microphone.": "Остановите ответ и включите микрофон.",
    "THE TEN-TURN CITY CHALLENGE": "ГОРОДСКОЙ КОНКУРС «ДЕСЯТЬ ПОВОРОТОВ»",
    "THINKING": "МЫШЛЕНИЕ",
    "Talk with {name}": "Поговорите с {name}",
    "The challenge could not be loaded. Try again.": "Задание не удалось загрузить. Попробуй еще раз.",
    "The conversation was interrupted. Your challenge is saved; reconnect when ready.": "Беседа была прервана. Задание сохранено; подключитесь снова, когда будете готовы.",
    "The restart could not be completed. Close this panel, reload progress, and try again.": "Не удалось завершить перезагрузку. Закройте эту панель, обновите прогресс и повторите попытку.",
    "The results are saved. Equal scores share a place.": "Результаты сохранены. Равные баллы делят место.",
    "There is no new result to collect.": "Нет новых результатов, которые можно было бы собрать.",
    "This challenge is complete.": "Эта задача выполнена.",
    "This challenge is no longer current.": "Эта проблема больше не актуальна.",
    "This challenge keeps its {language} opponents and progress. Your next challenge or an explicit Restart Game will use {next}.": "Это соревнование удерживает соперников {language} и продолжает прогрессировать. В следующем задании или при повторном запуске игры вы будете использовать {next}.",
    "This landmark is already complete.": "Эта веха уже завершена.",
    "This resets your regular city and challenge buildings, scores, and coins. Three competitors will be chosen at random again.": "Это перезапустит ваш обычный город и бросьте вызов зданиям, баллам и монетам. Три участника снова будут выбраны случайным образом.",
    "Three AI city builders. Ten turns. Your next great neighborhood.": "Три градостроителя с искусственным интеллектом. Десять ходов. Ваш следующий отличный район.",
    "Three competitors are chosen at random from the six who speak your selected language.": "Три участника выбираются случайным образом из шести участников, говорящих на выбранном вами языке.",
    "Tower specialist": "Специалист по башням",
    "Turn {v0} of 10": "Раз {v0} из 10",
    "Unknown challenge action.": "Неизвестное испытательное действие.",
    "Updating your challenge…": "Обновление задания...",
    "View challenge results": "Посмотреть результаты конкурса",
    "Visit city": "Посетите город",
    "Visiting {v0}": "В гостях у {v0}",
    "Wait for the current response, or press Speak to interrupt.": "Дождитесь текущего ответа или нажмите кнопку Speak для прерывания.",
    "YOU": "ВЫ",
    "YOUR MOVE": "ВАШ ХОД",
    "You": "Ты",
    "You and three competitors each receive 24,000 challenge coins and ten turns. Roll, then upgrade one landmark or save your coins. Every upgrade earns one point.": "Каждый из вас и трех участников получит по 24 000 монет за испытания и десять ходов. Прокатитесь, а затем улучшите одну достопримечательность или сэкономьте монеты. За каждое улучшение вы получаете одно очко.",
    "You keep your {rolls} regular rolls and {turns} remaining challenge turns.": "Вы сохраняете обычные роллы {rolls}, а оставшиеся ходы за испытаниями {turns}.",
    "You need more challenge coins for that upgrade.": "Для этого апгрейда вам нужно больше монет за испытания.",
    "You rolled {dice} and earned {coins} challenge coins.": "Вы набрали {dice} и заработали монеты {coins} Challenge.",
    "You rolled {v0}. Choose Build or Save below to finish your turn. All three opponents go next.": "Вы выбрали {v0}. Выберите «Собрать» или «Сохранить» ниже, чтобы завершить ход. Все три соперника идут дальше.",
    "You saved your coins and continued to the next roll.": "Вы сохранили монеты и перешли к следующему броску.",
    "You saved your coins for a future upgrade.": "Вы сохранили монеты для будущего обновления.",
    "You share first place!": "Вы делите первое место!",
    "You upgraded {landmark} to level {level}.": "Вы улучшили {landmark} до уровня {level}.",
    "Your challenge changed in another window. The latest progress has been loaded.": "Ваша задача изменилась в другом окне. Последняя информация о прогрессе загружена.",
    "Your challenge city": "Ваш город вызовов",
    "Your challenge record": "Ваш рекорд испытаний",
    "Your challenge turn": "Ваш черед испытаний",
    "Your city": "Ваш город",
    "Your opponents take their turns after either choice. Roll again to save automatically, let them play, then take your next roll.": "После любого выбора ваши противники решают свои очереди. Выполните повторный бросок, чтобы автоматически сохранить игру, дайте им сыграть, а затем сделайте следующий бросок.",
    "Your regular city stays separate. Extra rolls from the Shop do not count here. Equal scores share the same place.": "Ваш обычный город остается отдельным. Дополнительные рулоны из магазина здесь не учитываются. Равные баллы делятся на одном и том же месте.",
    "Your skyline": "Ваш горизонт",
    "Your skyline wins!": "Ваш горизонт выигрывает!",
    "Your turn · rolling the dice…": "Твой ход · бросание кубиков...",
    "pts": "очков",
    "rolls remaining": "осталось бросков",
    "{coins} challenge coins": "Монеты для испытаний {coins}",
    "{coins} challenge coins · Last dice {dice}": "Монеты конкурса {coins} · Последние кости {dice}",
    "{coins} coins": "{coins} монеты",
    "{count} challenge rounds left": "Осталось {count} раундов испытаний",
    "{language} challenge · {round} / 10 rounds complete": "Испытание {language} · {round}/Завершено 10 раундов",
    "{name} rolled {dice}, earned {coins} coins, and saved for a future upgrade.": "{name} выпустил {dice}, заработал монеты {coins} и сохранил их для будущего обновления.",
    "{name} rolled {dice}, earned {coins} coins, and upgraded {landmark} to level {level}.": "{name} выпустил {dice}, заработал монеты {coins} и повысил {landmark} до уровня {level}.",
    "{points} points": "{points} баллов",
    "{points} points · {coins} coins": "{points} очков · {coins} монеты",
    "{rolls} ROLLS REMAINING": "ОСТАЛОСЬ БРОСКОВ: {rolls}",
    "{v0} coins · Level {v1} → {v2}": "{v0} монеты · Уровень {v1} → {v2}",
    "{v0} points · {v1} coins": "{v0} очков · {v1} монеты",
    "{v0} · Level {v1} / 3": "{v0} · Уровень {v1}/3",
    "{v0}'s challenge city": "Город вызовов {v0}",
    "{v0}’s skyline": "Горизонт {v0}",
    "← Back to your city": "← Возвращение в свой город",
    "◉ Speak": "◉ Говорите",
    "◉ Talk": "◉ Разговор",
    "ADMIN ACCESS": "ДОСТУП АДМИНИСТРАТОРА",
    "Adding…": "Добавление...",
    "{rolls} rolls added at no charge.": "Роллы {rolls} добавляются бесплатно.",
    "Choose any roll package. No charge will be made.": "Выберите любую рулонную упаковку. Оплата не будет взиматься.",
    "Admin · Free": "Администрирование · Бесплатно",
    "{rolls} ROLLS": "БРОСКОВ: {rolls}"
  },
  "es-ES": {
    "24,000 coins · 10 turns": "24.000 monedas · 10 turnos",
    "3D city unavailable. Your buildings and scores are shown below.": "Ciudad 3D no disponible. Tus edificios y puntuaciones se muestran a continuación.",
    "A city worth building.": "Una ciudad que vale la pena construir.",
    "A friendly race to the skyline.": "Una carrera amistosa hacia el horizonte.",
    "A request identifier is required.": "Se requiere un identificador de solicitud.",
    "AI PLAYER": "JUGADOR AI",
    "AI competitor": "Competidor de IA",
    "All three opponents finished round {round}.": "Los tres oponentes terminaron la ronda {round}.",
    "An AI player, powered by Experts Alive. Conversations cannot spend coins or change the result.": "Un reproductor de IA, impulsado por Experts Alive. Las conversaciones no pueden gastar monedas ni cambiar el resultado.",
    "Ask": "Preguntar",
    "Ask about their strategy": "Pregunte acerca de su estrategia",
    "Ask your competitor": "Pregúntele a su competidor",
    "Available for the random draw": "Disponible para el sorteo aleatorio",
    "Balanced builder": "Constructor equilibrado",
    "Broadway House": "Casa Broadway",
    "Brooklyn Crossing": "Cruce de Brooklyn",
    "Build": "Construir",
    "Build & finish turn": "Construir y terminar turno",
    "Build and finish challenge turn": "Construye y termina el turno de desafío",
    "Build once or save": "Crea una vez o ahorra",
    "Buy more rolls": "Compra más rollos",
    "CHALLENGE CITY · NEW YORK": "CIUDAD DEL DESAFÍO · NUEVA YORK",
    "CONNECTING": "CONECTANDO",
    "Central Gardens": "Jardines centrales",
    "Challenge complete": "Desafío completado",
    "Challenge controls": "Controles de desafío",
    "Challenge standings": "Clasificación del desafío",
    "Challenge · Round {v0} of 10": "Desafío · Ronda {v0} de 10",
    "Challenge · {round} of 10 rounds complete": "Desafío · {round} de 10 rondas completadas",
    "Choose challenge landmark": "Elige el hito del desafío",
    "Choose one of the five landmarks.": "Elige uno de los cinco puntos de referencia.",
    "Choose one of the thirteen supported languages.": "Elige uno de los trece idiomas admitidos.",
    "Choose your landmark · one upgrade earns one point": "Elige tu punto de referencia · una mejora te otorga un punto",
    "Close ×": "Cerrar ×",
    "Collect result": "Recopilar el resultado",
    "Collect saves this result in your challenge record. No coins or paid rewards are awarded.": "Collect guarda este resultado en tu registro de desafíos. No se otorgan monedas ni recompensas pagas.",
    "Complete": "Completa",
    "Connect online to talk with your competitor.": "Conéctese en línea para hablar con su competidor.",
    "Connect to Lucky Estates online to save and play a challenge.": "Conéctate a Lucky Estates en línea para ahorrar y jugar un desafío.",
    "DISCONNECTED": "DESCONECTADO",
    "Discuss the match, compare strategies, or ask about this city.": "Comenta el partido, compara estrategias o pregunta por esta ciudad.",
    "ERROR": "ERROR",
    "Entire city": "Toda la ciudad",
    "Everyone starts on the same block.": "Todos comienzan en la misma cuadra.",
    "FINAL STANDINGS": "CLASIFICACIÓN FINAL",
    "Finish your current challenge first.": "Termina primero tu desafío actual.",
    "First place: {names}. You earned {points} points.": "Primer puesto: {names}. Has ganado {points} puntos.",
    "Game restarted. Everyone keeps {count} remaining challenge turns; no rolls were added.": "Se reinició el juego. Todos mantienen el puesto {count} restantes en los turnos de desafío; no se ha añadido ninguna tirada.",
    "Game restarted. Your remaining rolls were preserved.": "Se reinició el juego. Las tiradas restantes se conservaron.",
    "Harbor Beacon": "Baliza del puerto",
    "IDLE": "OCIOSO",
    "Keep playing": "Sigue jugando",
    "LISTENING": "ESCUCHANDO",
    "Latest moves": "Últimos movimientos",
    "Level {level} / 3": "Nivel {level}/3",
    "Listening — ask your question.": "Escuchar: haga su pregunta.",
    "Loading challenge…": "Cargando desafío...",
    "Loading…": "Cargando...",
    "Meet your competitors": "Conoce a tus competidores",
    "Next goal · Start a city challenge": "Próximo objetivo · Iniciar un desafío urbano",
    "No new rolls are added. Your language, avatar, audio preferences, and previously collected gifts are kept.": "No se añaden rollos nuevos. Se conservarán tu idioma, avatar, preferencias de audio y los regalos que hayas recolectado anteriormente.",
    "No purchases needed": "No se necesitan compras",
    "Not enough coins for an upgrade": "No hay suficientes monedas para una mejora",
    "Opponent language: {language}": "Idioma oponente: {language}",
    "Opponents completed their turns": "Los oponentes completaron sus turnos",
    "Optional visits and conversations. Your Lucky guide remains available through Explain this.": "Visitas y conversaciones opcionales. Tu guía afortunada permanece disponible a través de Explain this.",
    "Or Roll to save and continue automatically.": "O rodar para guardar y continuar automáticamente.",
    "PLAYERS · CITY CHALLENGE": "JUGADORES · DESAFÍO DE LA CIUDAD",
    "Place {place} · {points} points": "Puesto {place} · {points} puntos",
    "Play with {language} opponents": "Juega con oponentes {language}",
    "Players": "Jugadores",
    "Players ↗": "Jugadores ↗",
    "Prefer to keep your coins?": "¿Prefieres quedarte con tus monedas?",
    "Quick builder": "Constructor rápido",
    "READY": "LISTO",
    "ROUND {round}": "RONDA {round}",
    "Reconnect": "Vuelva a conectar",
    "Reload progress": "Recargar el progreso",
    "Restart Game": "Reiniciar juego",
    "Restart Game?": "¿Reiniciar el juego?",
    "Restarting…": "Reiniciando...",
    "Rivals take their turns": "Los rivales se turnan",
    "Roll again · auto-save coins": "Tirar otra vez · guardar monedas automáticamente",
    "Roll before choosing a building or saving.": "Tira antes de elegir un edificio o guardarlo.",
    "Roll challenge dice": "Tira los dados del desafío",
    "Roll for coins": "Rollo para monedas",
    "Roll here or use the orange Roll button on Play to take your challenge turn.": "Tira aquí o usa el botón naranja de Roll en Play para pasar tu turno de desafío.",
    "Roll, then choose Build or Save above the Roll button.": "Tira y, a continuación, selecciona Construir o Guardar encima del botón Tirar.",
    "SPEAKING": "HABLANDO",
    "Save coins": "Ahorra monedas",
    "Save coins & finish turn →": "Guarda monedas y termina el turno →",
    "Save coins and finish challenge turn": "Ahorra monedas y termina el turno de desafío",
    "Save coins for your next upgrade": "Guarda monedas para tu próxima mejora",
    "Save your regular game successfully before restarting. Reload if another window changed your game.": "Guarda tu juego normal correctamente antes de reiniciarlo. Recarga si otra ventana ha cambiado tu juego.",
    "Saving your coins. Opponents take their turns first…": "Guardando tus monedas. Los oponentes se turnan primero...",
    "Saving your move and updating the challenge…": "Guardando tu jugada y actualizando el desafío...",
    "Saving…": "Ahorrando...",
    "Select a landmark to look closer": "Selecciona un punto de referencia para verlo más de cerca",
    "Setting up your city…": "Configurando tu ciudad...",
    "Skyline Tower": "Torre Skyline",
    "Start 10-turn challenge": "Comienza el desafío de 10 turnos",
    "Start 10-turn challenge →": "Comienza el desafío de 10 turnos →",
    "Start another challenge": "Iniciar otro desafío",
    "Stop the response and turn on your microphone.": "Detenga la respuesta y encienda el micrófono.",
    "THE TEN-TURN CITY CHALLENGE": "EL DESAFÍO DE LA CIUDAD DE DIEZ CURVAS",
    "THINKING": "PENSANDO",
    "Talk with {name}": "Hable con {name}",
    "The challenge could not be loaded. Try again.": "No se pudo cargar el desafío. Vuelva a intentarlo.",
    "The conversation was interrupted. Your challenge is saved; reconnect when ready.": "La conversación se interrumpió. Tu desafío está guardado; vuelve a conectarte cuando estés listo.",
    "The restart could not be completed. Close this panel, reload progress, and try again.": "No se pudo completar el reinicio. Cierre este panel, vuelva a cargar el progreso e inténtelo de nuevo.",
    "The results are saved. Equal scores share a place.": "Los resultados se guardan. Las puntuaciones iguales comparten un lugar.",
    "There is no new result to collect.": "No hay ningún resultado nuevo que recopilar.",
    "This challenge is complete.": "Este desafío está completo.",
    "This challenge is no longer current.": "Este desafío ya no es actual.",
    "This challenge keeps its {language} opponents and progress. Your next challenge or an explicit Restart Game will use {next}.": "Este desafío mantiene a sus oponentes {language} y su progreso. Tu próximo desafío o una partida de reinicio explícita usará el {next}.",
    "This landmark is already complete.": "Este hito ya está completo.",
    "This resets your regular city and challenge buildings, scores, and coins. Three competitors will be chosen at random again.": "Esto restablece tu ciudad habitual y desafía los edificios, las puntuaciones y las monedas. Se volverá a elegir al azar a tres competidores.",
    "Three AI city builders. Ten turns. Your next great neighborhood.": "Tres constructores de ciudades con IA. Diez turnos. Tu próximo gran vecindario.",
    "Three competitors are chosen at random from the six who speak your selected language.": "Se eligen tres competidores al azar de entre los seis que hablan el idioma seleccionado.",
    "Tower specialist": "Especialista en torres",
    "Turn {v0} of 10": "Turno {v0} de 10",
    "Unknown challenge action.": "Acción de desafío desconocida.",
    "Updating your challenge…": "Actualizando tu desafío...",
    "View challenge results": "Ver los resultados del desafío",
    "Visit city": "Visita la ciudad",
    "Visiting {v0}": "Visitando {v0}",
    "Wait for the current response, or press Speak to interrupt.": "Espere la respuesta actual o pulse Hablar para interrumpir.",
    "YOU": "TÚ",
    "YOUR MOVE": "TU MOVIMIENTO",
    "You": "Tú",
    "You and three competitors each receive 24,000 challenge coins and ten turns. Roll, then upgrade one landmark or save your coins. Every upgrade earns one point.": "Tú y tres competidores recibís cada uno 24 000 monedas de desafío y diez turnos. Tira y, a continuación, mejora un punto de referencia o guarda tus monedas. Con cada mejora se gana un punto.",
    "You keep your {rolls} regular rolls and {turns} remaining challenge turns.": "Mantienes tus tiradas normales {rolls} y las {turns} que te quedan en los turnos de desafío.",
    "You need more challenge coins for that upgrade.": "Necesitas más monedas de desafío para esa mejora.",
    "You rolled {dice} and earned {coins} challenge coins.": "Has sacado {dice} con los dados y has ganado {coins} monedas del desafío.",
    "You rolled {v0}. Choose Build or Save below to finish your turn. All three opponents go next.": "Has sacado {v0} con los dados. Elige Construir o Guardar para terminar tu turno. Después jugarán los tres oponentes.",
    "You saved your coins and continued to the next roll.": "Guardaste tus monedas y pasaste a la siguiente tirada.",
    "You saved your coins for a future upgrade.": "Has guardado tus monedas para una futura mejora.",
    "You share first place!": "¡Compartes el primer lugar!",
    "You upgraded {landmark} to level {level}.": "Has mejorado el {landmark} al nivel {level}.",
    "Your challenge changed in another window. The latest progress has been loaded.": "Tu desafío cambió en otra ventana. Se ha cargado el progreso más reciente.",
    "Your challenge city": "Tu ciudad de desafío",
    "Your challenge record": "Tu historial de desafíos",
    "Your challenge turn": "Tu turno de desafío",
    "Your city": "Tu ciudad",
    "Your opponents take their turns after either choice. Roll again to save automatically, let them play, then take your next roll.": "Tus oponentes se turnan después de cualquiera de las dos opciones. Vuelve a tirar para guardar automáticamente, deja que jueguen y haz tu siguiente tirada.",
    "Your regular city stays separate. Extra rolls from the Shop do not count here. Equal scores share the same place.": "Tu ciudad habitual permanece separada. Las tiradas adicionales de la tienda no cuentan aquí. Las puntuaciones iguales comparten el mismo lugar.",
    "Your skyline": "Tu horizonte",
    "Your skyline wins!": "¡Tu horizonte gana!",
    "Your turn · rolling the dice…": "Tu turno · tirar los dados...",
    "pts": "puntos",
    "rolls remaining": "tiradas restantes",
    "{coins} challenge coins": "Monedas de desafío {coins}",
    "{coins} challenge coins · Last dice {dice}": "{coins} monedas de desafío · Último dado {dice}",
    "{coins} coins": "{coins} monedas",
    "{count} challenge rounds left": "Quedan {count} rondas de desafío",
    "{language} challenge · {round} / 10 rounds complete": "Desafío {language} · {round}/10 rondas completadas",
    "{name} rolled {dice}, earned {coins} coins, and saved for a future upgrade.": "{name} obtuvo {dice}, ganó {coins} monedas y las guardó para una mejora futura.",
    "{name} rolled {dice}, earned {coins} coins, and upgraded {landmark} to level {level}.": "{name} obtuvo {dice}, ganó {coins} monedas y mejoró {landmark} al nivel {level}.",
    "{points} points": "{points} puntos",
    "{points} points · {coins} coins": "{points} puntos · {coins} monedas",
    "{rolls} ROLLS REMAINING": "{rolls} TIRADAS RESTANTES",
    "{v0} coins · Level {v1} → {v2}": "{v0} monedas · Nivel {v1} → {v2}",
    "{v0} points · {v1} coins": "{v0} puntos · {v1} monedas",
    "{v0} · Level {v1} / 3": "{v0} · Nivel {v1}/3",
    "{v0}'s challenge city": "La ciudad desafiante de {v0}",
    "{v0}’s skyline": "El horizonte de {v0}",
    "← Back to your city": "← De vuelta a tu ciudad",
    "◉ Speak": "◉ Habla",
    "◉ Talk": "◉ Hablar",
    "ADMIN ACCESS": "ACCESO DE ADMINISTRADOR",
    "Adding…": "Agregando...",
    "{rolls} rolls added at no charge.": "Los rollos {rolls} se añaden sin coste alguno.",
    "Choose any roll package. No charge will be made.": "Elige cualquier paquete de rollos. No se realizará ningún cargo.",
    "Admin · Free": "Admin · Gratis",
    "{rolls} ROLLS": "{rolls} TIRADAS"
  },
  "vi-VN": {
    "24,000 coins · 10 turns": "24.000 đồng xu · 10 lượt",
    "3D city unavailable. Your buildings and scores are shown below.": "Thành phố 3D không khả dụng. Các tòa nhà và điểm số của bạn được hiển thị bên dưới.",
    "A city worth building.": "Một thành phố đáng để xây dựng",
    "A friendly race to the skyline.": "Một cuộc đua thân thiện đến đường chân trời.",
    "A request identifier is required.": "Cần có định danh yêu cầu.",
    "AI PLAYER": "NGƯỜI CHƠI AI",
    "AI competitor": "Đối thủ cạnh tranh AI",
    "All three opponents finished round {round}.": "Cả ba đối thủ đều kết thúc vòng {round}.",
    "An AI player, powered by Experts Alive. Conversations cannot spend coins or change the result.": "Một trình phát AI, được cung cấp bởi Experters Alive. Cuộc trò chuyện không thể tiêu tiền hoặc thay đổi kết quả.",
    "Ask": "Hỏi",
    "Ask about their strategy": "Hỏi về chiến lược của họ",
    "Ask your competitor": "Hỏi đối thủ cạnh tranh",
    "Available for the random draw": "Có sẵn cho bốc thăm ngẫu nhiên",
    "Balanced builder": "Người xây dựng cân bằng",
    "Broadway House": "Nhà Broadway",
    "Brooklyn Crossing": "Băng qua Brooklyn",
    "Build": "Xây dựng",
    "Build & finish turn": "Xây dựng và hoàn thành lượt",
    "Build and finish challenge turn": "Xây dựng và hoàn thành lượt thử thách",
    "Build once or save": "Xây dựng một lần hoặc lưu",
    "Buy more rolls": "Mua thêm cuộn",
    "CHALLENGE CITY · NEW YORK": "THÀNH PHỐ THỬ THÁCH · NEW YORK",
    "CONNECTING": "KẾT NỐI",
    "Central Gardens": "Vườn trung tâm",
    "Challenge complete": "Thử thách hoàn thành",
    "Challenge controls": "Kiểm soát thử thách",
    "Challenge standings": "Bảng xếp hạng thử thách",
    "Challenge · Round {v0} of 10": "Thử thách · Vòng {v0} trên 10",
    "Challenge · {round} of 10 rounds complete": "Thử thách · {round} trong số 10 vòng hoàn thành",
    "Choose challenge landmark": "Chọn cột mốc thử thách",
    "Choose one of the five landmarks.": "Chọn một trong năm địa danh.",
    "Choose one of the thirteen supported languages.": "Chọn một trong mười ba ngôn ngữ được hỗ trợ.",
    "Choose your landmark · one upgrade earns one point": "Chọn cột mốc của bạn · một lần nâng cấp kiếm được một điểm",
    "Close ×": "Đóng ×",
    "Collect result": "Thu thập kết quả",
    "Collect saves this result in your challenge record. No coins or paid rewards are awarded.": "Thu thập lưu kết quả này trong hồ sơ thử thách của bạn. Không có tiền xu hoặc phần thưởng trả tiền nào được trao.",
    "Complete": "Hoàn thành",
    "Connect online to talk with your competitor.": "Kết nối trực tuyến để nói chuyện với đối thủ cạnh tranh của bạn.",
    "Connect to Lucky Estates online to save and play a challenge.": "Kết nối với Lucky Estates trực tuyến để lưu và chơi thử thách.",
    "DISCONNECTED": "NGẮT KẾT NỐI",
    "Discuss the match, compare strategies, or ask about this city.": "Thảo luận về trận đấu, so sánh các chiến lược hoặc hỏi về thành phố này.",
    "ERROR": "LỖI",
    "Entire city": "Toàn bộ thành phố",
    "Everyone starts on the same block.": "Mọi người bắt đầu trên cùng một khối.",
    "FINAL STANDINGS": "BẢNG XẾP HẠNG CUỐI CÙNG",
    "Finish your current challenge first.": "Hoàn thành thử thách hiện tại của bạn trước.",
    "First place: {names}. You earned {points} points.": "Vị trí đầu tiên: {names}. Bạn đã kiếm được điểm {points}.",
    "Game restarted. Everyone keeps {count} remaining challenge turns; no rolls were added.": "Trò chơi khởi động lại. Mọi người giữ {count} lượt thử thách còn lại; không có cuộn nào được thêm vào.",
    "Game restarted. Your remaining rolls were preserved.": "Trò chơi khởi động lại. Các cuộn còn lại của bạn đã được bảo quản.",
    "Harbor Beacon": "Đèn hiệu cảng",
    "IDLE": "NHÀN RỖI",
    "Keep playing": "Tiếp tục chơi",
    "LISTENING": "LẮNG NGHE",
    "Latest moves": "Những động thái mới nhất",
    "Level {level} / 3": "Cấp độ {level}/3",
    "Listening — ask your question.": "Lắng nghe - đặt câu hỏi của bạn.",
    "Loading challenge…": "Đang tải thử thách...",
    "Loading…": "Đang tải...",
    "Meet your competitors": "Gặp gỡ đối thủ cạnh tranh",
    "Next goal · Start a city challenge": "Mục tiêu tiếp theo · Bắt đầu thử thách thành phố",
    "No new rolls are added. Your language, avatar, audio preferences, and previously collected gifts are kept.": "Không có cuộn mới nào được thêm vào. Ngôn ngữ, hình đại diện, tùy chọn âm thanh và quà tặng đã thu thập trước đó của bạn sẽ được giữ lại.",
    "No purchases needed": "Không cần mua hàng",
    "Not enough coins for an upgrade": "Không đủ tiền để nâng cấp",
    "Opponent language: {language}": "Ngôn ngữ đối thủ: {language}",
    "Opponents completed their turns": "Đối thủ đã hoàn thành lượt của họ",
    "Optional visits and conversations. Your Lucky guide remains available through Explain this.": "Lượt truy cập và trò chuyện tùy chọn. Hướng dẫn may mắn của bạn vẫn có sẵn thông qua Giải thích điều này.",
    "Or Roll to save and continue automatically.": "Hoặc cuộn để lưu và tiếp tục tự động.",
    "PLAYERS · CITY CHALLENGE": "NGƯỜI CHƠI · CITY CHALLENGE",
    "Place {place} · {points} points": "Vị trí {place} · {points} điểm",
    "Play with {language} opponents": "Chơi với đối thủ {language}",
    "Players": "Người chơi",
    "Players ↗": "Người chơi ↗",
    "Prefer to keep your coins?": "Bạn muốn giữ tiền xu của bạn?",
    "Quick builder": "Người xây dựng nhanh",
    "READY": "SẴN SÀNG",
    "ROUND {round}": "VÒNG {round}",
    "Reconnect": "Kết nối lại",
    "Reload progress": "Tải lại tiến độ",
    "Restart Game": "Khởi động lại trò chơi",
    "Restart Game?": "Khởi động lại trò chơi?",
    "Restarting…": "Khởi động lại...",
    "Rivals take their turns": "Các đối thủ thay phiên nhau",
    "Roll again · auto-save coins": "Roll again · tự động lưu tiền xu",
    "Roll before choosing a building or saving.": "Cuộn trước khi chọn một tòa nhà hoặc tiết kiệm.",
    "Roll challenge dice": "Tung xúc xắc thách thức",
    "Roll for coins": "Cuộn để lấy tiền",
    "Roll here or use the orange Roll button on Play to take your challenge turn.": "Lăn ở đây hoặc sử dụng nút Roll màu cam trên Play để thực hiện lượt thử thách của bạn.",
    "Roll, then choose Build or Save above the Roll button.": "Cuộn, sau đó chọn Build hoặc Save phía trên nút Roll.",
    "SPEAKING": "NÓI",
    "Save coins": "Tiết kiệm tiền",
    "Save coins & finish turn →": "Tiết kiệm tiền xu và hoàn thành lượt →",
    "Save coins and finish challenge turn": "Tiết kiệm tiền xu và hoàn thành lượt thử thách",
    "Save coins for your next upgrade": "Lưu tiền xu cho lần nâng cấp tiếp theo của bạn",
    "Save your regular game successfully before restarting. Reload if another window changed your game.": "Lưu trò chơi thông thường của bạn thành công trước khi khởi động lại. Tải lại nếu một cửa sổ khác thay đổi trò chơi của bạn.",
    "Saving your coins. Opponents take their turns first…": "Tiết kiệm tiền xu của bạn. Đối thủ thay phiên nhau trước...",
    "Saving your move and updating the challenge…": "Lưu động thái của bạn và cập nhật thử thách...",
    "Saving…": "Tiết kiệm...",
    "Select a landmark to look closer": "Chọn một cột mốc để xem xét kỹ hơn",
    "Setting up your city…": "Thiết lập thành phố của bạn...",
    "Skyline Tower": "Tháp Skyline",
    "Start 10-turn challenge": "Bắt đầu thử thách 10 lượt",
    "Start 10-turn challenge →": "Bắt đầu thử thách 10 lượt →",
    "Start another challenge": "Bắt đầu một thử thách khác",
    "Stop the response and turn on your microphone.": "Dừng phản hồi và bật micrô của bạn.",
    "THE TEN-TURN CITY CHALLENGE": "THỬ THÁCH THÀNH PHỐ MƯỜI LƯỢT",
    "THINKING": "SUY NGHĨ",
    "Talk with {name}": "Nói chuyện với {name}",
    "The challenge could not be loaded. Try again.": "Thử thách không thể được tải. Thử lại lần nữa.",
    "The conversation was interrupted. Your challenge is saved; reconnect when ready.": "Cuộc trò chuyện bị gián đoạn. Thử thách của bạn được lưu lại; kết nối lại khi sẵn sàng.",
    "The restart could not be completed. Close this panel, reload progress, and try again.": "Khởi động lại không thể hoàn thành. Đóng bảng điều khiển này, tải lại tiến trình và thử lại.",
    "The results are saved. Equal scores share a place.": "Kết quả được lưu lại. Điểm bằng nhau chia sẻ một vị trí.",
    "There is no new result to collect.": "Không có kết quả mới để thu thập.",
    "This challenge is complete.": "Thử thách này đã hoàn thành.",
    "This challenge is no longer current.": "Thách thức này không còn hiện tại nữa.",
    "This challenge keeps its {language} opponents and progress. Your next challenge or an explicit Restart Game will use {next}.": "Thử thách này giữ cho đối thủ {language} của nó và tiến bộ. Thử thách tiếp theo của bạn hoặc một Trò chơi Khởi động lại rõ ràng sẽ sử dụng {next}.",
    "This landmark is already complete.": "Cột mốc này đã hoàn thành.",
    "This resets your regular city and challenge buildings, scores, and coins. Three competitors will be chosen at random again.": "Điều này đặt lại thành phố thông thường của bạn và thách thức các tòa nhà, điểm số và tiền xu. Ba đối thủ cạnh tranh sẽ được chọn ngẫu nhiên một lần nữa.",
    "Three AI city builders. Ten turns. Your next great neighborhood.": "Ba nhà xây dựng thành phố AI. Mười lượt. Khu phố tuyệt vời tiếp theo của bạn.",
    "Three competitors are chosen at random from the six who speak your selected language.": "Ba đối thủ cạnh tranh được chọn ngẫu nhiên từ sáu người nói ngôn ngữ bạn đã chọn.",
    "Tower specialist": "Chuyên gia tháp",
    "Turn {v0} of 10": "Lượt {v0} trên 10",
    "Unknown challenge action.": "Hành động thử thách không xác định.",
    "Updating your challenge…": "Cập nhật thử thách của bạn...",
    "View challenge results": "Xem kết quả thử thách",
    "Visit city": "Tham quan thành phố",
    "Visiting {v0}": "Đang ghé thăm {v0}",
    "Wait for the current response, or press Speak to interrupt.": "Đợi phản hồi hiện tại hoặc nhấn Nói để ngắt.",
    "YOU": "BẠN",
    "YOUR MOVE": "ĐỘNG THÁI CỦA BẠN",
    "You": "Bạn",
    "You and three competitors each receive 24,000 challenge coins and ten turns. Roll, then upgrade one landmark or save your coins. Every upgrade earns one point.": "Bạn và ba đối thủ cạnh tranh mỗi người nhận được 24.000 xu thử thách và mười lượt. Cuộn, sau đó nâng cấp một cột mốc hoặc lưu tiền xu của bạn. Mỗi nâng cấp kiếm được một điểm.",
    "You keep your {rolls} regular rolls and {turns} remaining challenge turns.": "Bạn giữ nguyên lượt {rolls} thường xuyên và lượt thử thách {turns} còn lại.",
    "You need more challenge coins for that upgrade.": "Bạn cần nhiều tiền thử thách hơn cho việc nâng cấp đó.",
    "You rolled {dice} and earned {coins} challenge coins.": "Bạn đã lăn {dice} và kiếm được tiền thử thách {coins}.",
    "You rolled {v0}. Choose Build or Save below to finish your turn. All three opponents go next.": "Bạn đã lăn {v0}. Chọn Build hoặc Save bên dưới để hoàn thành lượt của bạn. Cả ba đối thủ đều đi tiếp theo.",
    "You saved your coins and continued to the next roll.": "Bạn đã lưu tiền xu của mình và tiếp tục cuộn tiếp theo.",
    "You saved your coins for a future upgrade.": "Bạn đã lưu tiền xu của mình để nâng cấp trong tương lai.",
    "You share first place!": "Bạn chia sẻ vị trí đầu tiên!",
    "You upgraded {landmark} to level {level}.": "Bạn đã nâng cấp {landmark} lên cấp {level}.",
    "Your challenge changed in another window. The latest progress has been loaded.": "Thử thách của bạn đã thay đổi trong một cửa sổ khác. Tiến trình mới nhất đã được tải.",
    "Your challenge city": "Thành phố thử thách của bạn",
    "Your challenge record": "Hồ sơ thử thách của bạn",
    "Your challenge turn": "Bước thử thách của bạn",
    "Your city": "Thành phố của bạn",
    "Your opponents take their turns after either choice. Roll again to save automatically, let them play, then take your next roll.": "Đối thủ của bạn thay phiên nhau sau một trong hai lựa chọn. Cuộn lại để lưu tự động, để chúng chơi, sau đó thực hiện cuộn tiếp theo của bạn.",
    "Your regular city stays separate. Extra rolls from the Shop do not count here. Equal scores share the same place.": "Thành phố thông thường của bạn vẫn tách biệt. Các cuộn bổ sung từ Cửa hàng không được tính ở đây. Điểm bằng nhau chia sẻ cùng một vị trí.",
    "Your skyline": "Đường chân trời của bạn",
    "Your skyline wins!": "Đường chân trời của bạn thắng!",
    "Your turn · rolling the dice…": "Đến lượt bạn · lăn xúc xắc...",
    "pts": "điểm",
    "rolls remaining": "lượt đổ còn lại",
    "{coins} challenge coins": "{coins} đồng xu thử thách",
    "{coins} challenge coins · Last dice {dice}": "{coins} challenge coins · Số xúc xắc cuối cùng {dice}",
    "{coins} coins": "{coins} đồng xu",
    "{count} challenge rounds left": "Vòng thử thách {count} còn lại",
    "{language} challenge · {round} / 10 rounds complete": "Thử thách {language} · {round}/Hoàn thành 10 vòng",
    "{name} rolled {dice}, earned {coins} coins, and saved for a future upgrade.": "{name} lăn {dice}, kiếm được {coins} coin và lưu lại để nâng cấp trong tương lai.",
    "{name} rolled {dice}, earned {coins} coins, and upgraded {landmark} to level {level}.": "{name} lăn {dice}, kiếm được {coins} coin và nâng cấp {landmark} lên cấp {level}.",
    "{points} points": "{points} điểm",
    "{points} points · {coins} coins": "{points} điểm · {coins} tiền xu",
    "{rolls} ROLLS REMAINING": "CÒN {rolls} LƯỢT ĐỔ",
    "{v0} coins · Level {v1} → {v2}": "{v0} tiền xu · Cấp {v1} → {v2}",
    "{v0} points · {v1} coins": "{v0} điểm · {v1} tiền xu",
    "{v0} · Level {v1} / 3": "{v0} · Cấp {v1}/3",
    "{v0}'s challenge city": "Thành phố thử thách của {v0}",
    "{v0}’s skyline": "Đường chân trời của {v0}",
    "← Back to your city": "← Trở lại thành phố của bạn",
    "◉ Speak": "◉ Nói",
    "◉ Talk": "◉ Nói chuyện",
    "Adding…": "Thêm vào...",
    "ADMIN ACCESS": "QUYỀN TRUY CẬP QUẢN TRỊ VIÊN",
    "Choose any roll package. No charge will be made.": "Chọn bất kỳ gói cuộn nào. Sẽ không tính phí.",
    "Admin · Free": "Admin · Miễn phí",
    "{rolls} rolls added at no charge.": "{rolls} cuộn được thêm vào miễn phí.",
    "{rolls} ROLLS": "{rolls} LƯỢT ĐỔ"
  }
}
